import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var coinSvg = /*#__PURE__*/_jsxs("svg", {
  id: "Group_10822",
  "data-name": "Group 10822",
  xmlns: "http://www.w3.org/2000/svg",
  className: "h-full w-16 md:w-20",
  width: "0",
  height: "0",
  viewBox: "0 0 96.652 66.51",
  children: [/*#__PURE__*/_jsx("g", {
    id: "Group_10693",
    "data-name": "Group 10693",
    transform: "translate(67.218 35.947)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10692",
      "data-name": "Group 10692",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10685",
        "data-name": "Group 10685",
        transform: "translate(0.285 9.533)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10684",
          "data-name": "Group 10684",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6549",
            "data-name": "Path 6549",
            d: "M80.926,72.115,80.775,75.3c-.032.22-.058.441-.068.665-.256,5.419,5.918,10.112,13.79,10.484,7.669.362,14.117-3.511,14.682-8.721h.009l.012-.258c0-.054.011-.106.013-.16s0-.107,0-.161l.176-3.691Z",
            transform: "translate(-80.7 -72.115)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10687",
        "data-name": "Group 10687",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10686",
          "data-name": "Group 10686",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1689",
            "data-name": "Ellipse 1689",
            cx: "9.822",
            cy: "14.269",
            rx: "9.822",
            ry: "14.269",
            transform: "translate(0 19.622) rotate(-87.295)",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10689",
        "data-name": "Group 10689",
        transform: "translate(3.262 2.323)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10688",
          "data-name": "Group 10688",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1690",
            "data-name": "Ellipse 1690",
            cx: "7.645",
            cy: "11.107",
            rx: "7.645",
            ry: "11.107",
            transform: "translate(0 15.274) rotate(-87.295)",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10691",
        "data-name": "Group 10691",
        transform: "translate(4.112 2.93)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10690",
          "data-name": "Group 10690",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1691",
            "data-name": "Ellipse 1691",
            cx: "7.077",
            cy: "10.283",
            rx: "7.077",
            ry: "10.283",
            transform: "translate(0 14.139) rotate(-87.295)",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10703",
    "data-name": "Group 10703",
    transform: "translate(3.517 34.849)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10702",
      "data-name": "Group 10702",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10695",
        "data-name": "Group 10695",
        transform: "translate(0 9.542)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10694",
          "data-name": "Group 10694",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6550",
            "data-name": "Path 6550",
            d: "M32.738,74.509v-3.7H4.242V74c-.022.221-.037.443-.037.668,0,5.424,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4h.009v-.258c0-.054.006-.106.006-.161S32.739,74.562,32.738,74.509Z",
            transform: "translate(-4.205 -70.813)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10697",
        "data-name": "Group 10697",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10696",
          "data-name": "Group 10696",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1692",
            "data-name": "Ellipse 1692",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10699",
        "data-name": "Group 10699",
        transform: "translate(3.163 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10698",
          "data-name": "Group 10698",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1693",
            "data-name": "Ellipse 1693",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10701",
        "data-name": "Group 10701",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10700",
          "data-name": "Group 10700",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1694",
            "data-name": "Ellipse 1694",
            cx: "10.283",
            cy: "7.078",
            rx: "10.283",
            ry: "7.078",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10713",
    "data-name": "Group 10713",
    transform: "translate(0.432 27.588)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10712",
      "data-name": "Group 10712",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10705",
        "data-name": "Group 10705",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10704",
          "data-name": "Group 10704",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6551",
            "data-name": "Path 6551",
            d: "M29.05,65.828v-3.7H.554v3.189c-.022.221-.037.443-.037.668,0,5.425,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4h.009V66.15c0-.054.006-.106.006-.161S29.051,65.882,29.05,65.828Z",
            transform: "translate(-0.517 -62.132)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10707",
        "data-name": "Group 10707",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10706",
          "data-name": "Group 10706",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1695",
            "data-name": "Ellipse 1695",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10709",
        "data-name": "Group 10709",
        transform: "translate(3.163 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10708",
          "data-name": "Group 10708",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1696",
            "data-name": "Ellipse 1696",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10711",
        "data-name": "Group 10711",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10710",
          "data-name": "Group 10710",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1697",
            "data-name": "Ellipse 1697",
            cx: "10.283",
            cy: "7.077",
            rx: "10.283",
            ry: "7.077",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10723",
    "data-name": "Group 10723",
    transform: "translate(1.235 21.201)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10722",
      "data-name": "Group 10722",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10715",
        "data-name": "Group 10715",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10714",
          "data-name": "Group 10714",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6552",
            "data-name": "Path 6552",
            d: "M30.011,58.192V54.5H1.514v3.189c-.022.221-.037.443-.037.668,0,5.425,6.389,9.822,14.269,9.822,7.677,0,13.936-4.174,14.254-9.4h.009v-.258c0-.054.006-.107.006-.161S30.011,58.246,30.011,58.192Z",
            transform: "translate(-1.477 -54.496)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10717",
        "data-name": "Group 10717",
        transform: "translate(0.001)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10716",
          "data-name": "Group 10716",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1698",
            "data-name": "Ellipse 1698",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10719",
        "data-name": "Group 10719",
        transform: "translate(3.164 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10718",
          "data-name": "Group 10718",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1699",
            "data-name": "Ellipse 1699",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10721",
        "data-name": "Group 10721",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10720",
          "data-name": "Group 10720",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1700",
            "data-name": "Ellipse 1700",
            cx: "10.283",
            cy: "7.077",
            rx: "10.283",
            ry: "7.077",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10733",
    "data-name": "Group 10733",
    transform: "translate(0 13.068)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10732",
      "data-name": "Group 10732",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10725",
        "data-name": "Group 10725",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10724",
          "data-name": "Group 10724",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6553",
            "data-name": "Path 6553",
            d: "M28.533,48.469v-3.7H.037v3.189C.015,48.182,0,48.4,0,48.63c0,5.425,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4h.009v-.258c0-.054.006-.106.006-.161S28.534,48.523,28.533,48.469Z",
            transform: "translate(0 -44.773)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10727",
        "data-name": "Group 10727",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10726",
          "data-name": "Group 10726",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1701",
            "data-name": "Ellipse 1701",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10729",
        "data-name": "Group 10729",
        transform: "translate(3.163 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10728",
          "data-name": "Group 10728",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1702",
            "data-name": "Ellipse 1702",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10731",
        "data-name": "Group 10731",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10730",
          "data-name": "Group 10730",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1703",
            "data-name": "Ellipse 1703",
            cx: "10.283",
            cy: "7.078",
            rx: "10.283",
            ry: "7.078",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10743",
    "data-name": "Group 10743",
    transform: "translate(35.501 35.542)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10742",
      "data-name": "Group 10742",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10735",
        "data-name": "Group 10735",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10734",
          "data-name": "Group 10734",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6554",
            "data-name": "Path 6554",
            d: "M70.976,75.336v-3.7h-28.5v3.189c-.022.221-.037.443-.037.667,0,5.424,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4h.009v-.258c0-.054.006-.106.006-.161S70.976,75.39,70.976,75.336Z",
            transform: "translate(-42.442 -71.64)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10737",
        "data-name": "Group 10737",
        transform: "translate(0.001)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10736",
          "data-name": "Group 10736",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1704",
            "data-name": "Ellipse 1704",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10739",
        "data-name": "Group 10739",
        transform: "translate(3.164 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10738",
          "data-name": "Group 10738",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1705",
            "data-name": "Ellipse 1705",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10741",
        "data-name": "Group 10741",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10740",
          "data-name": "Group 10740",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1706",
            "data-name": "Ellipse 1706",
            cx: "10.283",
            cy: "7.078",
            rx: "10.283",
            ry: "7.078",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10753",
    "data-name": "Group 10753",
    transform: "translate(36.202 30.182)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10752",
      "data-name": "Group 10752",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10745",
        "data-name": "Group 10745",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10744",
          "data-name": "Group 10744",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6555",
            "data-name": "Path 6555",
            d: "M71.813,68.929v-3.7h-28.5v3.189c-.022.221-.037.443-.037.668,0,5.425,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4h.009V69.25c0-.054.006-.107.006-.161S71.813,68.983,71.813,68.929Z",
            transform: "translate(-43.279 -65.233)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10747",
        "data-name": "Group 10747",
        transform: "translate(0.001)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10746",
          "data-name": "Group 10746",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1707",
            "data-name": "Ellipse 1707",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10749",
        "data-name": "Group 10749",
        transform: "translate(3.164 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10748",
          "data-name": "Group 10748",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1708",
            "data-name": "Ellipse 1708",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10751",
        "data-name": "Group 10751",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10750",
          "data-name": "Group 10750",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1709",
            "data-name": "Ellipse 1709",
            cx: "10.283",
            cy: "7.078",
            rx: "10.283",
            ry: "7.078",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10763",
    "data-name": "Group 10763",
    transform: "translate(35.156 21.618)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10762",
      "data-name": "Group 10762",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10755",
        "data-name": "Group 10755",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10754",
          "data-name": "Group 10754",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6556",
            "data-name": "Path 6556",
            d: "M70.562,58.69v-3.7h-28.5v3.189c-.022.221-.037.443-.037.667,0,5.425,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4h.009v-.258c0-.054.006-.106.006-.161S70.563,58.744,70.562,58.69Z",
            transform: "translate(-42.029 -54.994)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10757",
        "data-name": "Group 10757",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10756",
          "data-name": "Group 10756",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1710",
            "data-name": "Ellipse 1710",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10759",
        "data-name": "Group 10759",
        transform: "translate(3.163 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10758",
          "data-name": "Group 10758",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1711",
            "data-name": "Ellipse 1711",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10761",
        "data-name": "Group 10761",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10760",
          "data-name": "Group 10760",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1712",
            "data-name": "Ellipse 1712",
            cx: "10.283",
            cy: "7.078",
            rx: "10.283",
            ry: "7.078",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10773",
    "data-name": "Group 10773",
    transform: "translate(64.872 30.319)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10772",
      "data-name": "Group 10772",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10765",
        "data-name": "Group 10765",
        transform: "translate(0.285 9.532)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10764",
          "data-name": "Group 10764",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6557",
            "data-name": "Path 6557",
            d: "M78.122,65.386l-.151,3.185c-.032.22-.058.441-.068.665-.256,5.419,5.918,10.112,13.79,10.484,7.669.362,14.117-3.511,14.682-8.721h.009l.013-.258c0-.054.011-.106.013-.16s0-.107,0-.161l.174-3.692Z",
            transform: "translate(-77.896 -65.386)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10767",
        "data-name": "Group 10767",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10766",
          "data-name": "Group 10766",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1713",
            "data-name": "Ellipse 1713",
            cx: "9.822",
            cy: "14.269",
            rx: "9.822",
            ry: "14.269",
            transform: "translate(0 19.622) rotate(-87.295)",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10769",
        "data-name": "Group 10769",
        transform: "translate(3.262 2.323)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10768",
          "data-name": "Group 10768",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1714",
            "data-name": "Ellipse 1714",
            cx: "7.645",
            cy: "11.107",
            rx: "7.645",
            ry: "11.107",
            transform: "translate(0 15.274) rotate(-87.295)",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10771",
        "data-name": "Group 10771",
        transform: "translate(4.112 2.93)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10770",
          "data-name": "Group 10770",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1715",
            "data-name": "Ellipse 1715",
            cx: "7.077",
            cy: "10.283",
            rx: "7.077",
            ry: "10.283",
            transform: "translate(0 14.139) rotate(-87.295)",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10783",
    "data-name": "Group 10783",
    transform: "translate(3.88 6.534)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10782",
      "data-name": "Group 10782",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10775",
        "data-name": "Group 10775",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10774",
          "data-name": "Group 10774",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6558",
            "data-name": "Path 6558",
            d: "M33.172,40.657v-3.7H4.676V40.15c-.022.221-.037.443-.037.668,0,5.425,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4h.009v-.258c0-.054.006-.106.006-.161S33.173,40.711,33.172,40.657Z",
            transform: "translate(-4.639 -36.961)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10777",
        "data-name": "Group 10777",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10776",
          "data-name": "Group 10776",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1716",
            "data-name": "Ellipse 1716",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10779",
        "data-name": "Group 10779",
        transform: "translate(3.163 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10778",
          "data-name": "Group 10778",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1717",
            "data-name": "Ellipse 1717",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10781",
        "data-name": "Group 10781",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10780",
          "data-name": "Group 10780",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1718",
            "data-name": "Ellipse 1718",
            cx: "10.283",
            cy: "7.078",
            rx: "10.283",
            ry: "7.078",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "Group_10793",
    "data-name": "Group 10793",
    transform: "translate(0.976)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10792",
      "data-name": "Group 10792",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Group_10785",
        "data-name": "Group 10785",
        transform: "translate(0 9.541)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10784",
          "data-name": "Group 10784",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_6559",
            "data-name": "Path 6559",
            d: "M29.7,32.846v-3.7H1.2v3.189c-.022.221-.037.443-.037.668,0,5.424,6.389,9.822,14.269,9.822,7.677,0,13.936-4.173,14.254-9.4H29.7v-.258c0-.054.006-.106.006-.161S29.7,32.9,29.7,32.846Z",
            transform: "translate(-1.167 -29.15)",
            fill: "#d6a041"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10787",
        "data-name": "Group 10787",
        transform: "translate(0.001)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10786",
          "data-name": "Group 10786",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1719",
            "data-name": "Ellipse 1719",
            cx: "14.269",
            cy: "9.822",
            rx: "14.269",
            ry: "9.822",
            fill: "#ffcc5c"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10789",
        "data-name": "Group 10789",
        transform: "translate(3.164 2.176)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10788",
          "data-name": "Group 10788",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1720",
            "data-name": "Ellipse 1720",
            cx: "11.107",
            cy: "7.645",
            rx: "11.107",
            ry: "7.645",
            fill: "#fff"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_10791",
        "data-name": "Group 10791",
        transform: "translate(3.987 2.744)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_10790",
          "data-name": "Group 10790",
          children: /*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1721",
            "data-name": "Ellipse 1721",
            cx: "10.283",
            cy: "7.078",
            rx: "10.283",
            ry: "7.078",
            fill: "#ffeead"
          })
        })
      })]
    })
  }), /*#__PURE__*/_jsxs("g", {
    id: "Group_10806",
    "data-name": "Group 10806",
    transform: "translate(14.694 36.545)",
    children: [/*#__PURE__*/_jsx("g", {
      id: "Group_10795",
      "data-name": "Group 10795",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10794",
        "data-name": "Group 10794",
        children: /*#__PURE__*/_jsx("circle", {
          id: "Ellipse_1722",
          "data-name": "Ellipse 1722",
          cx: "13.843",
          cy: "13.843",
          r: "13.843",
          fill: "#ffcc5c"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10797",
      "data-name": "Group 10797",
      transform: "translate(0 2.279)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10796",
        "data-name": "Group 10796",
        children: /*#__PURE__*/_jsx("circle", {
          id: "Ellipse_1723",
          "data-name": "Ellipse 1723",
          cx: "13.843",
          cy: "13.843",
          r: "13.843",
          fill: "#d6a041"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10799",
      "data-name": "Group 10799",
      transform: "translate(3.068 5.348)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10798",
        "data-name": "Group 10798",
        children: /*#__PURE__*/_jsx("circle", {
          id: "Ellipse_1724",
          "data-name": "Ellipse 1724",
          cx: "10.775",
          cy: "10.775",
          r: "10.775",
          fill: "#fff"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10801",
      "data-name": "Group 10801",
      transform: "translate(3.868 6.147)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10800",
        "data-name": "Group 10800",
        children: /*#__PURE__*/_jsx("circle", {
          id: "Ellipse_1725",
          "data-name": "Ellipse 1725",
          cx: "9.975",
          cy: "9.975",
          r: "9.975",
          fill: "#ffeead"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10803",
      "data-name": "Group 10803",
      transform: "translate(9.739 8.268)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10802",
        "data-name": "Group 10802",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6560",
          "data-name": "Path 6560",
          d: "M35.453,78.407c-1.384-1.054-2.067-1.571-2.067-2.067a.283.283,0,0,1,.269-.31c.166,0,.537.785.682.785l2.831-.145c.145-.021.228-.1.228-.227a3.766,3.766,0,0,0-3.059-3.783c0-1.22,0-1.343-.166-1.343H32.661a.167.167,0,0,0-.145.186v1.138a3.668,3.668,0,0,0-2.955,3.617A4.331,4.331,0,0,0,31.5,79.813c1.633,1.178,2.129,1.633,2.129,2.17a.434.434,0,0,1-.454.455c-.476,0-.806-.434-.951-1.158-.041-.186-.1-.227-.228-.227l-2.625.145a.179.179,0,0,0-.165.186c0,2.439,1.137,3.864,3.307,4.258,0,1.24,0,1.384.165,1.384h1.488a.178.178,0,0,0,.166-.166v-1.2a3.638,3.638,0,0,0,3.079-3.844A4.293,4.293,0,0,0,35.453,78.407Z",
          transform: "translate(-29.21 -71.318)",
          fill: "#d6a041"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10805",
      "data-name": "Group 10805",
      transform: "translate(9.739 7.496)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10804",
        "data-name": "Group 10804",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6561",
          "data-name": "Path 6561",
          d: "M35.453,77.485c-1.384-1.054-2.067-1.571-2.067-2.067a.283.283,0,0,1,.269-.31c.166,0,.537.785.682.785l2.831-.145c.145-.021.228-.1.228-.228a3.766,3.766,0,0,0-3.059-3.783c0-1.22,0-1.343-.166-1.343H32.661a.167.167,0,0,0-.145.186v1.137a3.668,3.668,0,0,0-2.955,3.617A4.331,4.331,0,0,0,31.5,78.889c1.633,1.178,2.129,1.633,2.129,2.17a.434.434,0,0,1-.454.455c-.476,0-.806-.434-.951-1.158-.041-.186-.1-.227-.228-.227l-2.625.145a.179.179,0,0,0-.165.186c0,2.439,1.137,3.864,3.307,4.258,0,1.24,0,1.384.165,1.384h1.488a.178.178,0,0,0,.166-.166v-1.2a3.638,3.638,0,0,0,3.079-3.844A4.291,4.291,0,0,0,35.453,77.485Z",
          transform: "translate(-29.21 -70.395)",
          fill: "#ffcc5c"
        })
      })
    })]
  }), /*#__PURE__*/_jsxs("g", {
    id: "Group_10811",
    "data-name": "Group 10811",
    transform: "translate(9.726 2.732)",
    children: [/*#__PURE__*/_jsx("g", {
      id: "Group_10808",
      "data-name": "Group 10808",
      transform: "translate(0 0.62)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10807",
        "data-name": "Group 10807",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6562",
          "data-name": "Path 6562",
          d: "M19.122,27.444c-1.663-.847-2.482-1.261-2.482-1.66,0-.116.1-.249.323-.249.2,0,.645.631.819.631l3.4-.116c.173-.017.273-.083.273-.182,0-1.46-1.389-2.722-3.673-3.037,0-.979,0-1.079-.2-1.079H15.772a.16.16,0,0,0-.173.15v.913c-2.308.315-3.549,1.643-3.549,2.9,0,1.2.918,2.174,2.333,2.854,1.961.946,2.556,1.311,2.556,1.742,0,.216-.223.366-.546.366a1.161,1.161,0,0,1-1.142-.929c-.049-.149-.124-.182-.273-.182l-3.152.116c-.124.017-.2.066-.2.149,0,1.958,1.365,3.1,3.971,3.419,0,1,0,1.112.2,1.112h1.787c.1,0,.2-.066.2-.133v-.963c2.308-.3,3.7-1.427,3.7-3.087C21.479,29.153,20.66,28.224,19.122,27.444Z",
          transform: "translate(-11.628 -21.751)",
          fill: "#d6a041"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10810",
      "data-name": "Group 10810",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10809",
        "data-name": "Group 10809",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6563",
          "data-name": "Path 6563",
          d: "M19.122,26.7c-1.663-.847-2.482-1.261-2.482-1.66,0-.116.1-.249.323-.249.2,0,.645.631.819.631l3.4-.116c.173-.017.273-.083.273-.182,0-1.46-1.389-2.722-3.673-3.037,0-.979,0-1.079-.2-1.079H15.772a.16.16,0,0,0-.173.15v.913c-2.308.315-3.549,1.643-3.549,2.9,0,1.2.918,2.174,2.333,2.854,1.961.946,2.556,1.311,2.556,1.742,0,.216-.223.366-.546.366a1.161,1.161,0,0,1-1.142-.929c-.049-.149-.124-.182-.273-.182l-3.152.116c-.124.017-.2.066-.2.149,0,1.958,1.365,3.1,3.971,3.419,0,1,0,1.112.2,1.112h1.787c.1,0,.2-.066.2-.133v-.961c2.308-.3,3.7-1.427,3.7-3.087C21.479,28.413,20.66,27.483,19.122,26.7Z",
          transform: "translate(-11.628 -21.01)",
          fill: "#ffcc5c"
        })
      })
    })]
  }), /*#__PURE__*/_jsxs("g", {
    id: "Group_10816",
    "data-name": "Group 10816",
    transform: "translate(44.754 24.481)",
    children: [/*#__PURE__*/_jsx("g", {
      id: "Group_10813",
      "data-name": "Group 10813",
      transform: "translate(0 0.62)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10812",
        "data-name": "Group 10812",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6564",
          "data-name": "Path 6564",
          d: "M61,53.445c-1.663-.847-2.482-1.261-2.482-1.66,0-.116.1-.249.323-.249.2,0,.645.631.819.631l3.4-.116c.173-.017.273-.083.273-.182,0-1.46-1.389-2.722-3.673-3.037,0-.98,0-1.079-.2-1.079H57.647a.16.16,0,0,0-.173.15v.913c-2.308.315-3.549,1.643-3.549,2.9,0,1.2.918,2.174,2.333,2.854,1.961.946,2.556,1.311,2.556,1.742,0,.216-.223.366-.546.366a1.161,1.161,0,0,1-1.142-.929c-.049-.149-.124-.182-.273-.182l-3.152.116c-.124.017-.2.066-.2.149,0,1.958,1.365,3.1,3.971,3.419,0,1,0,1.112.2,1.112h1.787c.1,0,.2-.067.2-.133v-.963c2.308-.3,3.7-1.427,3.7-3.087C63.354,55.154,62.535,54.225,61,53.445Z",
          transform: "translate(-53.503 -47.752)",
          fill: "#d6a041"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10815",
      "data-name": "Group 10815",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10814",
        "data-name": "Group 10814",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6565",
          "data-name": "Path 6565",
          d: "M61,52.7c-1.663-.847-2.482-1.261-2.482-1.66,0-.116.1-.249.323-.249.2,0,.645.631.819.631l3.4-.116c.173-.017.273-.083.273-.182,0-1.46-1.389-2.722-3.673-3.037,0-.98,0-1.079-.2-1.079H57.647a.16.16,0,0,0-.173.15v.913c-2.308.315-3.549,1.643-3.549,2.9,0,1.2.918,2.174,2.333,2.854,1.961.946,2.556,1.311,2.556,1.742,0,.216-.223.366-.546.366a1.161,1.161,0,0,1-1.142-.929c-.049-.149-.124-.182-.273-.182l-3.152.116c-.124.017-.2.066-.2.149,0,1.958,1.365,3.1,3.971,3.419,0,1,0,1.112.2,1.112h1.787c.1,0,.2-.066.2-.133v-.963c2.308-.3,3.7-1.427,3.7-3.087C63.354,54.413,62.535,53.484,61,52.7Z",
          transform: "translate(-53.503 -47.011)",
          fill: "#ffcc5c"
        })
      })
    })]
  }), /*#__PURE__*/_jsxs("g", {
    id: "Group_10821",
    "data-name": "Group 10821",
    transform: "translate(74.247 34.332)",
    children: [/*#__PURE__*/_jsx("g", {
      id: "Group_10818",
      "data-name": "Group 10818",
      transform: "translate(0 0.62)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10817",
        "data-name": "Group 10817",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6566",
          "data-name": "Path 6566",
          d: "M96.256,65.222c-1.663-.847-2.482-1.261-2.482-1.66,0-.116.1-.249.323-.249.2,0,.645.631.819.631l3.4-.116c.173-.017.273-.083.273-.182,0-1.46-1.389-2.722-3.673-3.037,0-.979,0-1.079-.2-1.079H92.906a.16.16,0,0,0-.173.15v.913c-2.308.315-3.549,1.643-3.549,2.9,0,1.2.918,2.174,2.333,2.854,1.961.946,2.556,1.311,2.556,1.742,0,.216-.223.366-.546.366a1.161,1.161,0,0,1-1.142-.929c-.049-.149-.124-.182-.273-.182l-3.152.116c-.124.017-.2.066-.2.149,0,1.958,1.365,3.1,3.971,3.419,0,1,0,1.112.2,1.112h1.787c.1,0,.2-.066.2-.133v-.963c2.308-.3,3.7-1.427,3.7-3.087C98.613,66.931,97.794,66,96.256,65.222Z",
          transform: "translate(-88.762 -59.529)",
          fill: "#d6a041"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Group_10820",
      "data-name": "Group 10820",
      children: /*#__PURE__*/_jsx("g", {
        id: "Group_10819",
        "data-name": "Group 10819",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6567",
          "data-name": "Path 6567",
          d: "M96.256,64.481c-1.663-.847-2.482-1.261-2.482-1.66,0-.116.1-.249.323-.249.2,0,.645.631.819.631l3.4-.116c.173-.017.273-.083.273-.182,0-1.46-1.389-2.722-3.673-3.037,0-.979,0-1.079-.2-1.079H92.906a.16.16,0,0,0-.173.15v.913c-2.308.315-3.549,1.643-3.549,2.9,0,1.2.918,2.174,2.333,2.854,1.961.946,2.556,1.311,2.556,1.742,0,.216-.223.366-.546.366a1.161,1.161,0,0,1-1.142-.929c-.049-.149-.124-.182-.273-.182l-3.152.116c-.124.017-.2.066-.2.149,0,1.958,1.365,3.1,3.971,3.419,0,1,0,1.112.2,1.112h1.787c.1,0,.2-.066.2-.133V70.3c2.308-.3,3.7-1.427,3.7-3.087C98.613,66.19,97.794,65.261,96.256,64.481Z",
          transform: "translate(-88.762 -58.788)",
          fill: "#ffcc5c"
        })
      })
    })]
  })]
});
export var moneyBagSvg = /*#__PURE__*/_jsxs("svg", {
  className: "h-full w-10 md:w-12",
  xmlns: "http://www.w3.org/2000/svg",
  width: "0",
  height: "0",
  viewBox: "0 0 95.053 106.184",
  children: [/*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "linear-gradient",
      x1: "-0.045",
      y1: "0.603",
      x2: "0.446",
      y2: "0.603",
      gradientUnits: "objectBoundingBox",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0",
        "stop-color": "#fff"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        "stop-color": "#d17918"
      })]
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-2",
      x1: "-0.291",
      y1: "1.104",
      x2: "0.2",
      y2: "1.104"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-3",
      x1: "-0.537",
      y1: "1.605",
      x2: "-0.046",
      y2: "1.605"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-4",
      x1: "-2.092",
      y1: "-1.643",
      x2: "-1.601",
      y2: "-1.643"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-5",
      x1: "-2.338",
      y1: "-1.141",
      x2: "-1.847",
      y2: "-1.141"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-6",
      x1: "-2.584",
      y1: "-0.641",
      x2: "-2.093",
      y2: "-0.641"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-7",
      x1: "-2.83",
      y1: "-0.14",
      x2: "-2.339",
      y2: "-0.14"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-8",
      x1: "-3.076",
      y1: "0.361",
      x2: "-2.585",
      y2: "0.361"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-9",
      x1: "-0.77",
      y1: "-1.979",
      x2: "-0.279",
      y2: "-1.979"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-10",
      x1: "-1.016",
      y1: "-1.478",
      x2: "-0.525",
      y2: "-1.478"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-11",
      x1: "-1.262",
      y1: "-0.977",
      x2: "-0.771",
      y2: "-0.977"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-12",
      x1: "-1.508",
      y1: "-0.476",
      x2: "-1.017",
      y2: "-0.476"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-13",
      x1: "-1.754",
      y1: "0.025",
      x2: "-1.263",
      y2: "0.025"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-14",
      x1: "2.94",
      y1: "3.152",
      x2: "3.696",
      y2: "3.152"
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "linear-gradient-15",
      x1: "3.098",
      y1: "1.953",
      x2: "3.853",
      y2: "1.953"
    })]
  }), /*#__PURE__*/_jsxs("g", {
    id: "Group_10967",
    "data-name": "Group 10967",
    transform: "translate(0.004 0)",
    children: [/*#__PURE__*/_jsxs("g", {
      id: "Group_10962",
      "data-name": "Group 10962",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_6583",
        "data-name": "Path 6583",
        d: "M146,353.355c0,3.433-14.035,6.215-31.347,6.215s-31.347-2.783-31.347-6.215,14.035-6.215,31.347-6.215S146,349.923,146,353.355Z",
        transform: "translate(-83.31 -267.409)",
        opacity: "0.1"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6584",
        "data-name": "Path 6584",
        d: "M207.877,196.182s-5.477-27.743-26.075-40H167.08c-20.6,12.262-26.075,40-26.075,40-6.024,32.259,31.407,28.151,31.407,28.151h4.06S213.9,228.441,207.877,196.182Z",
        transform: "translate(-124.087 -130.892)",
        fill: "#e8c47b"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6585",
        "data-name": "Path 6585",
        d: "M212.626,196.182s-5.477-27.743-26.075-40h-8.182C192.361,168.5,196.292,188.4,196.292,188.4c5.5,29.465-28.687,25.713-28.687,25.713H163.9s-8.915.975-16.906-1.99c6.879,14.76,30.169,12.208,30.169,12.208h4.06s37.431,4.108,31.407-28.151Z",
        transform: "translate(-128.835 -130.892)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6586",
        "data-name": "Path 6586",
        d: "M178.588,74.733c-.764-1-1.97-3.167-.659-4.168,1.708-1.306,5.058.077,6.794.564A19.831,19.831,0,0,0,192,72.07c2.438-.254,5.212-1.608,7.376-2.486,2.192-.89,4.493-2.489,7.113-1.682,2.74.847,3.817,3.244,6.982,3.544,5.559.527,8.841-4.459,14.053-3.926,2.708.277,2.4,1.964.881,3.125l-20.15,22.12H193.533L178.59,74.73Z",
        transform: "translate(-150.537 -67.48)",
        fill: "#e8c47b"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group_10960",
        "data-name": "Group 10960",
        transform: "translate(32.566 55.46)",
        children: [/*#__PURE__*/_jsxs("g", {
          id: "Group_10959",
          "data-name": "Group 10959",
          children: [/*#__PURE__*/_jsx("path", {
            id: "Path_6587",
            "data-name": "Path 6587",
            d: "M294.645,400.951c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S301.419,400.951,294.645,400.951Z",
            transform: "translate(-258.191 -354.597)",
            fill: "#130e2f",
            opacity: "0.1"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6588",
            "data-name": "Path 6588",
            d: "M339.785,350.551c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S346.559,350.551,339.785,350.551Z",
            transform: "translate(-290.462 -318.566)",
            fill: "#ccc",
            opacity: "0.6"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6589",
            "data-name": "Path 6589",
            d: "M334.143,406.744c-6.768-.228-12.328,1.7-12.416,4.3s5.329,4.9,12.1,5.129,12.328-1.7,12.416-4.3S340.912,406.975,334.143,406.744Z",
            transform: "translate(-286.32 -365.467)",
            fill: "#130e2f",
            opacity: "0.1"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6590",
            "data-name": "Path 6590",
            d: "M213.314,379.394c6.768-.228,12.328,1.7,12.416,4.3s-5.329,4.9-12.1,5.129-12.328-1.7-12.416-4.3S206.546,379.625,213.314,379.394Z",
            transform: "translate(-200.167 -345.915)",
            fill: "#130e2f",
            opacity: "0.1"
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10916",
            "data-name": "Group 10916",
            transform: "translate(7.753 27.923)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6591",
              "data-name": "Path 6591",
              d: "M224.74,378.719c0,2.606,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V376.49H224.743v2.229Z",
              transform: "translate(-224.737 -371.774)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10914",
              "data-name": "Group 10914",
              transform: "translate(0.003 4.727)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6592",
                "data-name": "Path 6592",
                d: "M263.66,380.51v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-252.564 -379.375)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6593",
                "data-name": "Path 6593",
                d: "M255.37,380.51v5.6c.633.074,1.289.125,1.961.16v-5.76Z",
                transform: "translate(-246.637 -379.375)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6594",
                "data-name": "Path 6594",
                d: "M232.988,383.2v-6.67H224.74v2.218c0,2.064,3.447,3.817,8.248,4.456Z",
                transform: "translate(-224.74 -376.53)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6595",
                "data-name": "Path 6595",
                d: "M283.08,380.51V386l.4-.06v-5.428h-.4Z",
                transform: "translate(-266.447 -379.375)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6596",
                "data-name": "Path 6596",
                d: "M277.73,386.181c.134-.011.268-.026.4-.04V380.51h-.4Z",
                transform: "translate(-262.623 -379.375)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6597",
                "data-name": "Path 6597",
                d: "M270.95,380.5v5.785c.2-.006.391-.011.584-.023V380.5Z",
                transform: "translate(-257.776 -379.368)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10915",
              "data-name": "Group 10915",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6598",
                "data-name": "Path 6598",
                d: "M237,369.391c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S243.779,369.391,237,369.391Z",
                transform: "translate(-224.737 -359.957)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6599",
                "data-name": "Path 6599",
                d: "M243.906,368.613c-.348.011-.7.02-1.055.02-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.608,27.608,0,0,0,6.911-.82Z",
                transform: "translate(-224.73 -360)",
                opacity: "0.4",
                fill: "url(#linear-gradient)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6600",
                "data-name": "Path 6600",
                d: "M249.287,365.55c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S249.088,368.088,249.287,365.55Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-224.766 -360.686)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6601",
                "data-name": "Path 6601",
                d: "M251.964,374.186l-4.744,1.363v.946l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.028.219.043v.844h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762V374.22h-1.762v1.226a10.243,10.243,0,0,1-1.052-.014V374.22h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-240.808 -370.123)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6602",
                "data-name": "Path 6602",
                d: "M246.979,364.666c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S249.26,367.269,249.26,364.666Z",
                transform: "translate(-224.73 -359.95)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6603",
                "data-name": "Path 6603",
                d: "M237.37,368.133c0-1.836,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S237.37,369.972,237.37,368.133Zm16.946,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S254.316,369.889,254.316,368.133Z",
                transform: "translate(-233.766 -363.417)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6604",
                "data-name": "Path 6604",
                d: "M251.964,371.97l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.029.219.043v.847h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V372.01h-1.762v1.226a10.3,10.3,0,0,1-1.052-.014V372.01h-1.762v.864a2.206,2.206,0,0,1-1.018-.724Z",
                transform: "translate(-240.808 -368.543)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10919",
            "data-name": "Group 10919",
            transform: "translate(7.753 23.207)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6605",
              "data-name": "Path 6605",
              d: "M224.74,362.179c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V359.95H224.743v2.229Z",
              transform: "translate(-224.737 -355.234)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10917",
              "data-name": "Group 10917",
              transform: "translate(0.003 4.727)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6606",
                "data-name": "Path 6606",
                d: "M263.66,363.97v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-252.564 -362.835)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6607",
                "data-name": "Path 6607",
                d: "M255.37,363.97v5.6c.633.074,1.289.128,1.961.16v-5.76Z",
                transform: "translate(-246.637 -362.835)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6608",
                "data-name": "Path 6608",
                d: "M232.988,366.664V359.99H224.74v2.218c0,2.064,3.447,3.815,8.248,4.456Z",
                transform: "translate(-224.74 -359.99)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6609",
                "data-name": "Path 6609",
                d: "M283.08,363.97v5.491l.4-.06v-5.428h-.4Z",
                transform: "translate(-266.447 -362.835)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6610",
                "data-name": "Path 6610",
                d: "M277.73,369.641c.134-.011.268-.026.4-.04V363.97h-.4Z",
                transform: "translate(-262.623 -362.835)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6611",
                "data-name": "Path 6611",
                d: "M270.95,363.97v5.785c.2-.006.391-.011.584-.023V363.97Z",
                transform: "translate(-257.776 -362.835)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10918",
              "data-name": "Group 10918",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6612",
                "data-name": "Path 6612",
                d: "M237,352.841c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S243.779,352.841,237,352.841Z",
                transform: "translate(-224.737 -343.41)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6613",
                "data-name": "Path 6613",
                d: "M243.906,352.066q-.522.016-1.055.017c-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.61,27.61,0,0,0,6.911-.821Z",
                transform: "translate(-224.73 -343.453)",
                opacity: "0.4",
                fill: "url(#linear-gradient-2)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6614",
                "data-name": "Path 6614",
                d: "M249.287,349c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S249.088,351.538,249.287,349Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-224.766 -344.139)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6615",
                "data-name": "Path 6615",
                d: "M251.964,357.643l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.029.219.043v.847h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537h-1.762v1.226a10.287,10.287,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.183Z",
                transform: "translate(-240.808 -353.583)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6616",
                "data-name": "Path 6616",
                d: "M246.979,348.126c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S249.26,350.729,249.26,348.126Z",
                transform: "translate(-224.73 -343.41)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6617",
                "data-name": "Path 6617",
                d: "M237.37,351.593c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S237.37,353.432,237.37,351.593Zm16.946,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S254.316,353.349,254.316,351.593Z",
                transform: "translate(-233.766 -346.877)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6618",
                "data-name": "Path 6618",
                d: "M251.964,355.423l-4.744,1.363v.947l4.855-1.5a4.945,4.945,0,0,0,2.064.875l.219.043V358h1.762v-.65c.385.017.741.017,1.052.011V358h1.762v-2.54h-1.762v1.226a10.269,10.269,0,0,1-1.052-.014V355.46h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.18Z",
                transform: "translate(-240.808 -351.996)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10922",
            "data-name": "Group 10922",
            transform: "translate(7.753 18.492)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6619",
              "data-name": "Path 6619",
              d: "M224.74,345.629c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V343.4H224.743v2.229Z",
              transform: "translate(-224.737 -338.687)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10920",
              "data-name": "Group 10920",
              transform: "translate(0.003 4.724)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6620",
                "data-name": "Path 6620",
                d: "M263.66,347.42v5.78c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-252.564 -346.285)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6621",
                "data-name": "Path 6621",
                d: "M255.37,347.42v5.6c.633.074,1.289.128,1.961.16v-5.76Z",
                transform: "translate(-246.637 -346.285)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6622",
                "data-name": "Path 6622",
                d: "M232.988,350.114V343.44H224.74v2.218c0,2.064,3.447,3.815,8.248,4.456Z",
                transform: "translate(-224.74 -343.44)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6623",
                "data-name": "Path 6623",
                d: "M283.08,347.42v5.491l.4-.06V347.42Z",
                transform: "translate(-266.447 -346.285)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6624",
                "data-name": "Path 6624",
                d: "M277.73,353.091c.134-.011.268-.026.4-.04V347.42h-.4Z",
                transform: "translate(-262.623 -346.285)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6625",
                "data-name": "Path 6625",
                d: "M270.95,347.42v5.78c.2-.006.391-.011.584-.023V347.42Z",
                transform: "translate(-257.776 -346.285)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10921",
              "data-name": "Group 10921",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6626",
                "data-name": "Path 6626",
                d: "M237,336.3c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S243.779,336.3,237,336.3Z",
                transform: "translate(-224.737 -326.87)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6627",
                "data-name": "Path 6627",
                d: "M243.906,335.516q-.522.016-1.055.017c-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.61,27.61,0,0,0,6.911-.821Z",
                transform: "translate(-224.73 -326.906)",
                opacity: "0.4",
                fill: "url(#linear-gradient-3)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6628",
                "data-name": "Path 6628",
                d: "M249.287,332.46c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S249.088,335,249.287,332.46Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-224.766 -327.599)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6629",
                "data-name": "Path 6629",
                d: "M251.964,341.089l-4.744,1.363v.947l4.855-1.5a4.945,4.945,0,0,0,2.064.875c.071.017.145.029.219.043v.844h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537h-1.762v1.223a10.269,10.269,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-240.808 -337.029)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6630",
                "data-name": "Path 6630",
                d: "M246.979,331.586c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716S230.221,336.3,237,336.3,249.26,334.189,249.26,331.586Z",
                transform: "translate(-224.73 -326.87)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6631",
                "data-name": "Path 6631",
                d: "M237.37,335.053c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S237.37,336.892,237.37,335.053Zm16.946,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S254.316,336.809,254.316,335.053Z",
                transform: "translate(-233.766 -330.337)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6632",
                "data-name": "Path 6632",
                d: "M251.964,338.883l-4.744,1.363v.947l4.855-1.5a4.945,4.945,0,0,0,2.064.875l.219.043v.844h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V338.92h-1.762v1.226a10.269,10.269,0,0,1-1.052-.014V338.92h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.18Z",
                transform: "translate(-240.808 -335.456)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10925",
            "data-name": "Group 10925",
            transform: "translate(37.95 18.868)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6633",
              "data-name": "Path 6633",
              d: "M330.66,346.949c0,2.606,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V344.72H330.663v2.229Z",
              transform: "translate(-330.657 -340.007)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10923",
              "data-name": "Group 10923",
              transform: "translate(0 4.724)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6634",
                "data-name": "Path 6634",
                d: "M369.58,348.74v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-358.481 -347.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6635",
                "data-name": "Path 6635",
                d: "M361.28,348.74v5.6c.633.074,1.289.125,1.961.16v-5.76Z",
                transform: "translate(-352.547 -347.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6636",
                "data-name": "Path 6636",
                d: "M338.9,351.434V344.76h-8.25v2.218C330.65,349.042,334.1,350.8,338.9,351.434Z",
                transform: "translate(-330.65 -344.76)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6637",
                "data-name": "Path 6637",
                d: "M389,348.74v5.491l.4-.06v-5.428H389Z",
                transform: "translate(-372.364 -347.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6638",
                "data-name": "Path 6638",
                d: "M383.64,354.411c.134-.011.268-.026.4-.04V348.74h-.4Z",
                transform: "translate(-368.533 -347.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6639",
                "data-name": "Path 6639",
                d: "M376.86,348.733v5.785c.2-.006.391-.011.584-.023V348.73h-.584Z",
                transform: "translate(-363.686 -347.598)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10924",
              "data-name": "Group 10924",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6640",
                "data-name": "Path 6640",
                d: "M342.915,337.621c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716S355.18,330.3,355.18,332.9,349.689,337.621,342.915,337.621Z",
                transform: "translate(-330.65 -328.19)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6641",
                "data-name": "Path 6641",
                d: "M349.826,336.843c-.348.011-.7.02-1.055.02-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.608,27.608,0,0,0,6.911-.82Z",
                transform: "translate(-330.65 -328.233)",
                opacity: "0.4",
                fill: "url(#linear-gradient-4)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6642",
                "data-name": "Path 6642",
                d: "M355.2,333.78c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S355,336.318,355.2,333.78Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.481,3.84-9.986,3.84Z",
                transform: "translate(-330.679 -328.919)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6643",
                "data-name": "Path 6643",
                d: "M357.874,342.416l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875c.071.017.145.029.22.043v.844h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537h-1.762v1.226a10.278,10.278,0,0,1-1.052-.014v-1.212h-1.762v.864a2.2,2.2,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-346.721 -338.356)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6644",
                "data-name": "Path 6644",
                d: "M352.9,332.906c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S355.181,335.509,355.181,332.906Z",
                transform: "translate(-330.65 -328.19)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6645",
                "data-name": "Path 6645",
                d: "M343.29,336.373c0-1.836,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S343.29,338.212,343.29,336.373Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S360.233,338.129,360.233,336.373Z",
                transform: "translate(-339.686 -331.657)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6646",
                "data-name": "Path 6646",
                d: "M357.874,340.21l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V340.25h-1.762v1.226a10.3,10.3,0,0,1-1.052-.014V340.25h-1.762v.864a2.205,2.205,0,0,1-1.018-.724Z",
                transform: "translate(-346.721 -336.783)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10928",
            "data-name": "Group 10928",
            transform: "translate(37.95 14.149)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6647",
              "data-name": "Path 6647",
              d: "M330.66,330.409c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V328.18H330.663v2.229Z",
              transform: "translate(-330.657 -323.464)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10926",
              "data-name": "Group 10926",
              transform: "translate(0 4.727)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6648",
                "data-name": "Path 6648",
                d: "M369.58,332.2v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-358.481 -331.065)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6649",
                "data-name": "Path 6649",
                d: "M361.28,332.2v5.6c.633.074,1.289.128,1.961.16V332.2Z",
                transform: "translate(-352.547 -331.065)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6650",
                "data-name": "Path 6650",
                d: "M338.9,334.894V328.22h-8.25v2.218C330.65,332.5,334.1,334.253,338.9,334.894Z",
                transform: "translate(-330.65 -328.22)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6651",
                "data-name": "Path 6651",
                d: "M389,332.2v5.491l.4-.06V332.2Z",
                transform: "translate(-372.364 -331.065)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6652",
                "data-name": "Path 6652",
                d: "M383.64,337.871c.134-.011.268-.026.4-.04V332.2h-.4Z",
                transform: "translate(-368.533 -331.065)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6653",
                "data-name": "Path 6653",
                d: "M376.86,332.2v5.785c.2-.006.391-.011.584-.023V332.2Z",
                transform: "translate(-363.686 -331.065)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10927",
              "data-name": "Group 10927",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6654",
                "data-name": "Path 6654",
                d: "M342.915,321.081c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S349.689,321.081,342.915,321.081Z",
                transform: "translate(-330.65 -311.647)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6655",
                "data-name": "Path 6655",
                d: "M349.826,320.3q-.522.016-1.055.017c-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.609,27.609,0,0,0,6.911-.821Z",
                transform: "translate(-330.65 -311.683)",
                opacity: "0.4",
                fill: "url(#linear-gradient-5)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6656",
                "data-name": "Path 6656",
                d: "M355.2,317.24c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S355,319.778,355.2,317.24Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.481,3.84-9.986,3.84Z",
                transform: "translate(-330.679 -312.376)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6657",
                "data-name": "Path 6657",
                d: "M357.874,325.883l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537h-1.762v1.226a10.287,10.287,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-346.721 -321.82)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6658",
                "data-name": "Path 6658",
                d: "M352.9,316.356c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S355.181,318.959,355.181,316.356Z",
                transform: "translate(-330.65 -311.64)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6659",
                "data-name": "Path 6659",
                d: "M343.29,319.823c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S343.29,321.662,343.29,319.823Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S360.233,321.579,360.233,319.823Z",
                transform: "translate(-339.686 -315.107)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6660",
                "data-name": "Path 6660",
                d: "M357.874,323.653l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875l.22.043v.844h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V323.69h-1.762v1.226a10.278,10.278,0,0,1-1.052-.014V323.69h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.18Z",
                transform: "translate(-346.721 -320.226)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10931",
            "data-name": "Group 10931",
            transform: "translate(37.95 9.434)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6661",
              "data-name": "Path 6661",
              d: "M330.66,313.869c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V311.64H330.663v2.229Z",
              transform: "translate(-330.657 -306.924)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10929",
              "data-name": "Group 10929",
              transform: "translate(0 4.724)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6662",
                "data-name": "Path 6662",
                d: "M369.58,315.66v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-358.481 -314.522)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6663",
                "data-name": "Path 6663",
                d: "M361.28,315.66v5.6c.633.074,1.289.128,1.961.16v-5.76Z",
                transform: "translate(-352.547 -314.522)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6664",
                "data-name": "Path 6664",
                d: "M338.9,318.344V311.67h-8.25v2.218C330.65,315.952,334.1,317.7,338.9,318.344Z",
                transform: "translate(-330.65 -311.67)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6665",
                "data-name": "Path 6665",
                d: "M389,315.66v5.491l.4-.06v-5.428H389Z",
                transform: "translate(-372.364 -314.522)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6666",
                "data-name": "Path 6666",
                d: "M383.64,321.331c.134-.011.268-.026.4-.04V315.66h-.4Z",
                transform: "translate(-368.533 -314.522)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6667",
                "data-name": "Path 6667",
                d: "M376.86,315.66v5.785c.2-.006.391-.011.584-.023V315.66Z",
                transform: "translate(-363.686 -314.522)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10930",
              "data-name": "Group 10930",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6668",
                "data-name": "Path 6668",
                d: "M342.915,304.531c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S349.689,304.531,342.915,304.531Z",
                transform: "translate(-330.65 -295.1)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6669",
                "data-name": "Path 6669",
                d: "M349.826,303.756q-.522.016-1.055.017c-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.611,27.611,0,0,0,6.911-.821Z",
                transform: "translate(-330.65 -295.143)",
                opacity: "0.4",
                fill: "url(#linear-gradient-6)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6670",
                "data-name": "Path 6670",
                d: "M355.2,300.69c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S355,303.228,355.2,300.69Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.481,3.84-9.986,3.84Z",
                transform: "translate(-330.679 -295.829)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6671",
                "data-name": "Path 6671",
                d: "M357.874,309.319l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.029.22.043v.844h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537h-1.762v1.223a10.261,10.261,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-346.721 -305.259)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6672",
                "data-name": "Path 6672",
                d: "M352.9,299.816c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S355.181,302.419,355.181,299.816Z",
                transform: "translate(-330.65 -295.1)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6673",
                "data-name": "Path 6673",
                d: "M343.29,303.283c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S343.29,305.122,343.29,303.283Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S360.233,305.039,360.233,303.283Z",
                transform: "translate(-339.686 -298.567)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6674",
                "data-name": "Path 6674",
                d: "M357.874,307.113l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875l.22.043v.844h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V307.15h-1.762v1.226a10.287,10.287,0,0,1-1.052-.014V307.15h-1.762v.864a2.2,2.2,0,0,1-1.018-.724l-1.377-.18Z",
                transform: "translate(-346.721 -303.686)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10934",
            "data-name": "Group 10934",
            transform: "translate(37.95 4.718)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6675",
              "data-name": "Path 6675",
              d: "M330.66,297.319c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V295.09H330.663v2.229Z",
              transform: "translate(-330.657 -290.377)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10932",
              "data-name": "Group 10932",
              transform: "translate(0 4.724)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6676",
                "data-name": "Path 6676",
                d: "M369.58,299.11v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-358.481 -297.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6677",
                "data-name": "Path 6677",
                d: "M361.28,299.11v5.6c.633.074,1.289.125,1.961.16v-5.76Z",
                transform: "translate(-352.547 -297.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6678",
                "data-name": "Path 6678",
                d: "M338.9,301.8v-6.67h-8.25v2.218C330.65,299.412,334.1,301.163,338.9,301.8Z",
                transform: "translate(-330.65 -295.13)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6679",
                "data-name": "Path 6679",
                d: "M389,299.11v5.49l.4-.06v-5.428H389Z",
                transform: "translate(-372.364 -297.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6680",
                "data-name": "Path 6680",
                d: "M383.64,304.781c.134-.011.268-.026.4-.04V299.11h-.4Z",
                transform: "translate(-368.533 -297.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6681",
                "data-name": "Path 6681",
                d: "M376.86,299.1v5.785c.2-.006.391-.011.584-.023V299.1Z",
                transform: "translate(-363.686 -297.968)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10933",
              "data-name": "Group 10933",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6682",
                "data-name": "Path 6682",
                d: "M342.915,287.991c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S349.689,287.991,342.915,287.991Z",
                transform: "translate(-330.65 -278.56)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6683",
                "data-name": "Path 6683",
                d: "M349.826,287.213c-.348.011-.7.02-1.055.02-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.606,27.606,0,0,0,6.911-.82Z",
                transform: "translate(-330.65 -278.603)",
                opacity: "0.4",
                fill: "url(#linear-gradient-7)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6684",
                "data-name": "Path 6684",
                d: "M355.2,284.15c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S355,286.688,355.2,284.15Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.481,3.84-9.986,3.84Z",
                transform: "translate(-330.679 -279.289)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6685",
                "data-name": "Path 6685",
                d: "M357.874,292.786l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875c.071.017.145.029.22.043v.844h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762v-2.537h-1.762v1.226a10.278,10.278,0,0,1-1.052-.014v-1.212h-1.762v.864a2.205,2.205,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-346.721 -288.726)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6686",
                "data-name": "Path 6686",
                d: "M352.9,283.276c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S355.181,285.879,355.181,283.276Z",
                transform: "translate(-330.65 -278.56)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6687",
                "data-name": "Path 6687",
                d: "M343.29,286.743c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S343.29,288.582,343.29,286.743Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S360.233,288.5,360.233,286.743Z",
                transform: "translate(-339.686 -282.027)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6688",
                "data-name": "Path 6688",
                d: "M357.874,290.58l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V290.62h-1.762v1.226a10.269,10.269,0,0,1-1.052-.014V290.62h-1.762v.864a2.206,2.206,0,0,1-1.018-.724Z",
                transform: "translate(-346.721 -287.153)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10937",
            "data-name": "Group 10937",
            transform: "translate(37.95)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6689",
              "data-name": "Path 6689",
              d: "M330.66,280.779c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V278.55H330.663v2.229Z",
              transform: "translate(-330.657 -273.834)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10935",
              "data-name": "Group 10935",
              transform: "translate(0 4.727)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6690",
                "data-name": "Path 6690",
                d: "M369.58,282.57v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-358.481 -281.435)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6691",
                "data-name": "Path 6691",
                d: "M361.28,282.57v5.6c.633.074,1.289.125,1.961.16v-5.76Z",
                transform: "translate(-352.547 -281.435)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6692",
                "data-name": "Path 6692",
                d: "M338.9,285.264V278.59h-8.25v2.218C330.65,282.872,334.1,284.626,338.9,285.264Z",
                transform: "translate(-330.65 -278.59)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6693",
                "data-name": "Path 6693",
                d: "M389,282.57v5.491l.4-.06V282.57Z",
                transform: "translate(-372.364 -281.435)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6694",
                "data-name": "Path 6694",
                d: "M383.64,288.241c.134-.011.268-.026.4-.04V282.57h-.4Z",
                transform: "translate(-368.533 -281.435)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6695",
                "data-name": "Path 6695",
                d: "M376.86,282.563v5.785c.2-.006.391-.011.584-.023V282.56h-.584Z",
                transform: "translate(-363.686 -281.428)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10936",
              "data-name": "Group 10936",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6696",
                "data-name": "Path 6696",
                d: "M342.915,271.451c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S349.689,271.451,342.915,271.451Z",
                transform: "translate(-330.65 -262.017)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6697",
                "data-name": "Path 6697",
                d: "M349.826,270.673c-.348.011-.7.02-1.055.02-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.608,27.608,0,0,0,6.911-.82Z",
                transform: "translate(-330.65 -262.06)",
                opacity: "0.4",
                fill: "url(#linear-gradient-8)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6698",
                "data-name": "Path 6698",
                d: "M355.2,267.61c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S355,270.148,355.2,267.61Zm-12.256,3.99c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84S348.449,271.6,342.944,271.6Z",
                transform: "translate(-330.679 -262.746)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6699",
                "data-name": "Path 6699",
                d: "M357.874,276.253l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537h-1.762v1.226a10.287,10.287,0,0,1-1.052-.014v-1.212h-1.762v.864a2.205,2.205,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-346.721 -272.19)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6700",
                "data-name": "Path 6700",
                d: "M352.9,266.726c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S355.181,269.329,355.181,266.726Z",
                transform: "translate(-330.65 -262.01)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6701",
                "data-name": "Path 6701",
                d: "M343.29,270.193c0-1.836,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S343.29,272.032,343.29,270.193Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S360.233,271.949,360.233,270.193Z",
                transform: "translate(-339.686 -265.477)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6702",
                "data-name": "Path 6702",
                d: "M357.874,274.03l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875l.22.043v.847h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V274.07h-1.762v1.23a10.287,10.287,0,0,1-1.052-.014V274.07h-1.762v.864a2.205,2.205,0,0,1-1.018-.724Z",
                transform: "translate(-346.721 -270.603)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10940",
            "data-name": "Group 10940",
            transform: "translate(26.866 33.12)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6703",
              "data-name": "Path 6703",
              d: "M291.78,396.949c0,2.606,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V394.72H291.783v2.229Z",
              transform: "translate(-291.777 -390.004)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10938",
              "data-name": "Group 10938",
              transform: "translate(0 4.727)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6704",
                "data-name": "Path 6704",
                d: "M330.7,398.74v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-319.601 -397.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6705",
                "data-name": "Path 6705",
                d: "M322.4,398.74v5.6c.633.074,1.289.125,1.961.16v-5.76Z",
                transform: "translate(-313.667 -397.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6706",
                "data-name": "Path 6706",
                d: "M300.018,401.434V394.76H291.77v2.218C291.77,399.042,295.217,400.8,300.018,401.434Z",
                transform: "translate(-291.77 -394.76)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6707",
                "data-name": "Path 6707",
                d: "M350.12,398.74v5.491l.4-.06V398.74Z",
                transform: "translate(-333.484 -397.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6708",
                "data-name": "Path 6708",
                d: "M344.76,404.411c.134-.011.268-.026.4-.04V398.74h-.4Z",
                transform: "translate(-329.653 -397.605)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6709",
                "data-name": "Path 6709",
                d: "M337.98,398.733v5.785c.2-.006.391-.011.584-.023V398.73h-.584Z",
                transform: "translate(-324.806 -397.598)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10939",
              "data-name": "Group 10939",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6710",
                "data-name": "Path 6710",
                d: "M304.035,387.611c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716S316.3,380.293,316.3,382.9,310.809,387.611,304.035,387.611Z",
                transform: "translate(-291.77 -378.18)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6711",
                "data-name": "Path 6711",
                d: "M310.946,386.843c-.348.011-.7.02-1.055.02-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716A27.59,27.59,0,0,0,310.946,386.843Z",
                transform: "translate(-291.77 -378.23)",
                opacity: "0.4",
                fill: "url(#linear-gradient-9)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6712",
                "data-name": "Path 6712",
                d: "M316.317,383.77c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S316.118,386.308,316.317,383.77Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-291.799 -378.909)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6713",
                "data-name": "Path 6713",
                d: "M318.994,392.406l-4.744,1.363v.947l4.855-1.5a4.945,4.945,0,0,0,2.064.875c.071.017.145.029.22.043v.844h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537H324.2v1.226a10.3,10.3,0,0,1-1.052-.014v-1.212h-1.762v.864a2.205,2.205,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-307.841 -388.346)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6714",
                "data-name": "Path 6714",
                d: "M314.019,382.9c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716S291.77,380.3,291.77,382.9s5.491,4.716,12.265,4.716S316.3,385.5,316.3,382.9Z",
                transform: "translate(-291.77 -378.18)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6715",
                "data-name": "Path 6715",
                d: "M304.41,386.363c0-1.836,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S304.41,388.2,304.41,386.363Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S321.353,388.119,321.353,386.363Z",
                transform: "translate(-300.806 -381.647)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6716",
                "data-name": "Path 6716",
                d: "M318.994,390.2l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V390.24H324.2v1.226a10.287,10.287,0,0,1-1.052-.014V390.24h-1.762v.864a2.205,2.205,0,0,1-1.018-.724Z",
                transform: "translate(-307.841 -386.773)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10943",
            "data-name": "Group 10943",
            transform: "translate(26.866 28.404)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6717",
              "data-name": "Path 6717",
              d: "M291.78,380.4c0,2.6,5.491,4.716,12.265,4.716S316.31,383,316.31,380.4v-2.23H291.783v2.23Z",
              transform: "translate(-291.777 -373.457)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10941",
              "data-name": "Group 10941",
              transform: "translate(0 4.724)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6718",
                "data-name": "Path 6718",
                d: "M330.7,382.19v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-319.601 -381.055)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6719",
                "data-name": "Path 6719",
                d: "M322.4,382.19v5.6c.633.074,1.289.128,1.961.16v-5.76Z",
                transform: "translate(-313.667 -381.055)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6720",
                "data-name": "Path 6720",
                d: "M300.018,384.884V378.21H291.77v2.218C291.77,382.492,295.217,384.243,300.018,384.884Z",
                transform: "translate(-291.77 -378.21)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6721",
                "data-name": "Path 6721",
                d: "M350.12,382.19v5.491l.4-.06v-5.428h-.4Z",
                transform: "translate(-333.484 -381.055)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6722",
                "data-name": "Path 6722",
                d: "M344.76,387.861c.134-.011.268-.026.4-.04V382.19h-.4Z",
                transform: "translate(-329.653 -381.055)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6723",
                "data-name": "Path 6723",
                d: "M337.98,382.19v5.785c.2-.006.391-.011.584-.023V382.19Z",
                transform: "translate(-324.806 -381.055)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10942",
              "data-name": "Group 10942",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6724",
                "data-name": "Path 6724",
                d: "M304.035,371.071c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S310.809,371.071,304.035,371.071Z",
                transform: "translate(-291.77 -361.64)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6725",
                "data-name": "Path 6725",
                d: "M310.946,370.286q-.522.016-1.055.017c-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.592,27.592,0,0,0,6.911-.821Z",
                transform: "translate(-291.77 -361.676)",
                opacity: "0.4",
                fill: "url(#linear-gradient-10)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6726",
                "data-name": "Path 6726",
                d: "M316.317,367.23c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S316.118,369.768,316.317,367.23Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-291.799 -362.369)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6727",
                "data-name": "Path 6727",
                d: "M318.994,375.873l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537H324.2v1.226a10.278,10.278,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-307.841 -371.813)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6728",
                "data-name": "Path 6728",
                d: "M314.019,366.356c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S316.3,368.959,316.3,366.356Z",
                transform: "translate(-291.77 -361.64)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6729",
                "data-name": "Path 6729",
                d: "M304.41,369.823c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S304.41,371.662,304.41,369.823Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S321.353,371.579,321.353,369.823Z",
                transform: "translate(-300.806 -365.107)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6730",
                "data-name": "Path 6730",
                d: "M318.994,373.653l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875l.22.043v.844h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V373.69H324.2v1.226a10.3,10.3,0,0,1-1.052-.014V373.69h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.18Z",
                transform: "translate(-307.841 -370.226)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10946",
            "data-name": "Group 10946",
            transform: "translate(26.866 23.686)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6731",
              "data-name": "Path 6731",
              d: "M291.78,363.859c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V361.63H291.783v2.229Z",
              transform: "translate(-291.777 -356.914)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10944",
              "data-name": "Group 10944",
              transform: "translate(0 4.727)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6732",
                "data-name": "Path 6732",
                d: "M330.7,365.65v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-319.601 -364.515)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6733",
                "data-name": "Path 6733",
                d: "M322.4,365.65v5.6c.633.074,1.289.128,1.961.16v-5.76Z",
                transform: "translate(-313.667 -364.515)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6734",
                "data-name": "Path 6734",
                d: "M300.018,368.344V361.67H291.77v2.218C291.77,365.952,295.217,367.7,300.018,368.344Z",
                transform: "translate(-291.77 -361.67)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6735",
                "data-name": "Path 6735",
                d: "M350.12,365.65v5.491l.4-.06v-5.428h-.4Z",
                transform: "translate(-333.484 -364.515)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6736",
                "data-name": "Path 6736",
                d: "M344.76,371.321c.134-.011.268-.026.4-.04V365.65h-.4Z",
                transform: "translate(-329.653 -364.515)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6737",
                "data-name": "Path 6737",
                d: "M337.98,365.65v5.785c.2-.006.391-.011.584-.023V365.65Z",
                transform: "translate(-324.806 -364.515)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10945",
              "data-name": "Group 10945",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6738",
                "data-name": "Path 6738",
                d: "M304.035,354.531c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S310.809,354.531,304.035,354.531Z",
                transform: "translate(-291.77 -345.097)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6739",
                "data-name": "Path 6739",
                d: "M310.946,353.746q-.522.016-1.055.017c-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716a27.592,27.592,0,0,0,6.911-.821Z",
                transform: "translate(-291.77 -345.133)",
                opacity: "0.4",
                fill: "url(#linear-gradient-11)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6740",
                "data-name": "Path 6740",
                d: "M316.317,350.69c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S316.118,353.228,316.317,350.69Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-291.799 -345.826)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6741",
                "data-name": "Path 6741",
                d: "M318.994,359.326l-4.744,1.363v.947l4.855-1.5a4.945,4.945,0,0,0,2.064.875c.071.017.145.029.22.043v.844h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537H324.2v1.226a10.3,10.3,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-307.841 -355.263)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6742",
                "data-name": "Path 6742",
                d: "M314.019,349.806c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S316.3,352.409,316.3,349.806Z",
                transform: "translate(-291.77 -345.09)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6743",
                "data-name": "Path 6743",
                d: "M304.41,353.273c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S304.41,355.112,304.41,353.273Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S321.353,355.029,321.353,353.273Z",
                transform: "translate(-300.806 -348.557)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6744",
                "data-name": "Path 6744",
                d: "M318.994,357.1l-4.744,1.363v.947l4.855-1.5a4.944,4.944,0,0,0,2.064.875l.22.043v.844h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V357.14H324.2v1.226a10.287,10.287,0,0,1-1.052-.014V357.14h-1.762V358a2.205,2.205,0,0,1-1.018-.724l-1.377-.18Z",
                transform: "translate(-307.841 -353.676)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10949",
            "data-name": "Group 10949",
            transform: "translate(26.866 18.971)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6745",
              "data-name": "Path 6745",
              d: "M291.78,347.319c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V345.09H291.783v2.229Z",
              transform: "translate(-291.777 -340.374)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10947",
              "data-name": "Group 10947",
              transform: "translate(0 4.727)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6746",
                "data-name": "Path 6746",
                d: "M330.7,349.11v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-319.601 -347.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6747",
                "data-name": "Path 6747",
                d: "M322.4,349.11v5.6c.633.074,1.289.125,1.961.16v-5.76Z",
                transform: "translate(-313.667 -347.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6748",
                "data-name": "Path 6748",
                d: "M300.018,351.8v-6.67H291.77v2.218C291.77,349.412,295.217,351.163,300.018,351.8Z",
                transform: "translate(-291.77 -345.13)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6749",
                "data-name": "Path 6749",
                d: "M350.12,349.11v5.49l.4-.06v-5.43Z",
                transform: "translate(-333.484 -347.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6750",
                "data-name": "Path 6750",
                d: "M344.76,354.781c.134-.011.268-.026.4-.04V349.11h-.4Z",
                transform: "translate(-329.653 -347.975)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6751",
                "data-name": "Path 6751",
                d: "M337.98,349.1v5.785c.2-.006.391-.011.584-.023V349.1Z",
                transform: "translate(-324.806 -347.968)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10948",
              "data-name": "Group 10948",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6752",
                "data-name": "Path 6752",
                d: "M304.035,337.981c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S310.809,337.981,304.035,337.981Z",
                transform: "translate(-291.77 -328.55)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6753",
                "data-name": "Path 6753",
                d: "M310.946,337.213c-.348.011-.7.02-1.055.02-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716A27.59,27.59,0,0,0,310.946,337.213Z",
                transform: "translate(-291.77 -328.6)",
                opacity: "0.4",
                fill: "url(#linear-gradient-12)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6754",
                "data-name": "Path 6754",
                d: "M316.317,334.14c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S316.118,336.678,316.317,334.14Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-291.799 -329.279)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6755",
                "data-name": "Path 6755",
                d: "M318.994,342.776l-4.744,1.363v.947l4.855-1.5a4.945,4.945,0,0,0,2.064.875c.071.017.145.029.22.043v.844h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762v-2.537H324.2v1.226a10.287,10.287,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.183Z",
                transform: "translate(-307.841 -338.716)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6756",
                "data-name": "Path 6756",
                d: "M314.019,333.266c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S316.3,335.869,316.3,333.266Z",
                transform: "translate(-291.77 -328.55)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6757",
                "data-name": "Path 6757",
                d: "M304.41,336.733c0-1.839,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S304.41,338.572,304.41,336.733Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S321.353,338.489,321.353,336.733Z",
                transform: "translate(-300.806 -332.017)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6758",
                "data-name": "Path 6758",
                d: "M318.994,340.57l-4.744,1.363v.947l4.855-1.5a4.945,4.945,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V340.61H324.2v1.226a10.269,10.269,0,0,1-1.052-.014V340.61h-1.762v.864a2.206,2.206,0,0,1-1.018-.724Z",
                transform: "translate(-307.841 -337.143)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10952",
            "data-name": "Group 10952",
            transform: "translate(26.866 14.255)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6759",
              "data-name": "Path 6759",
              d: "M291.78,330.769c0,2.6,5.491,4.716,12.265,4.716s12.265-2.113,12.265-4.716V328.54H291.783v2.229Z",
              transform: "translate(-291.777 -323.827)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10950",
              "data-name": "Group 10950",
              transform: "translate(0 4.724)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6760",
                "data-name": "Path 6760",
                d: "M330.7,332.56v5.776c.385.014.773.023,1.166.023v-5.8Z",
                transform: "translate(-319.601 -331.425)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6761",
                "data-name": "Path 6761",
                d: "M322.4,332.56v5.6c.633.074,1.289.125,1.961.16v-5.76Z",
                transform: "translate(-313.667 -331.425)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6762",
                "data-name": "Path 6762",
                d: "M300.018,335.254V328.58H291.77v2.22C291.77,332.862,295.217,334.616,300.018,335.254Z",
                transform: "translate(-291.77 -328.58)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6763",
                "data-name": "Path 6763",
                d: "M350.12,332.56v5.491l.4-.06v-5.428h-.4Z",
                transform: "translate(-333.484 -331.425)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6764",
                "data-name": "Path 6764",
                d: "M344.76,338.231c.134-.011.268-.026.4-.04V332.56h-.4Z",
                transform: "translate(-329.653 -331.425)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6765",
                "data-name": "Path 6765",
                d: "M337.98,332.553v5.785c.2-.006.391-.011.584-.023V332.55h-.584Z",
                transform: "translate(-324.806 -331.418)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10951",
              "data-name": "Group 10951",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6766",
                "data-name": "Path 6766",
                d: "M304.035,321.441c-6.774,0-12.265-2.113-12.265-4.716s5.491-4.716,12.265-4.716,12.265,2.113,12.265,4.716S310.809,321.441,304.035,321.441Z",
                transform: "translate(-291.77 -312.01)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6767",
                "data-name": "Path 6767",
                d: "M310.946,320.663c-.348.011-.7.02-1.055.02-6.774,0-12.265-2.113-12.265-4.716,0-1.619,2.121-3.048,5.354-3.9-6.278.2-11.21,2.229-11.21,4.7,0,2.606,5.491,4.716,12.265,4.716A27.59,27.59,0,0,0,310.946,320.663Z",
                transform: "translate(-291.77 -312.053)",
                opacity: "0.4",
                fill: "url(#linear-gradient-13)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6768",
                "data-name": "Path 6768",
                d: "M316.317,317.6c-.2-2.537-5.608-4.57-12.254-4.57s-12.051,2.033-12.254,4.57c.2,2.537,5.608,4.57,12.254,4.57S316.118,320.138,316.317,317.6Zm-12.254,3.986c-5.505,0-9.981-1.722-9.981-3.84s4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84-4.478,3.84-9.983,3.84Z",
                transform: "translate(-291.799 -312.739)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6769",
                "data-name": "Path 6769",
                d: "M318.994,326.243l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875c.071.017.145.029.22.043v.847h1.762v-.65c.385.017.741.02,1.052.011v.639h1.762v-2.537H324.2v1.226a10.251,10.251,0,0,1-1.052-.014v-1.212h-1.762v.864a2.206,2.206,0,0,1-1.018-.724l-1.377-.182Z",
                transform: "translate(-307.841 -322.183)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6770",
                "data-name": "Path 6770",
                d: "M314.019,316.726c0,2.115-4.479,3.84-9.984,3.84s-9.981-1.722-9.981-3.84,4.479-3.84,9.981-3.84,9.984,1.722,9.984,3.84m2.281,0c0-2.606-5.491-4.716-12.265-4.716s-12.265,2.113-12.265,4.716,5.491,4.716,12.265,4.716S316.3,319.329,316.3,316.726Z",
                transform: "translate(-291.77 -312.01)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6771",
                "data-name": "Path 6771",
                d: "M304.41,320.193c0-1.836,3.886-3.333,8.664-3.333s8.664,1.494,8.664,3.333-3.886,3.333-8.664,3.333S304.41,322.032,304.41,320.193Zm16.943,0c0-1.756-3.715-3.185-8.282-3.185s-8.282,1.428-8.282,3.185,3.715,3.185,8.282,3.185S321.353,321.949,321.353,320.193Z",
                transform: "translate(-300.806 -315.477)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6772",
                "data-name": "Path 6772",
                d: "M318.994,324.03l-4.744,1.363v.947l4.855-1.5a4.943,4.943,0,0,0,2.064.875l.22.043v.847h1.762v-.65c.385.017.741.017,1.052.011v.639h1.762V324.07H324.2v1.23a10.3,10.3,0,0,1-1.052-.014V324.07h-1.762v.864a2.206,2.206,0,0,1-1.018-.724Z",
                transform: "translate(-307.841 -320.603)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6773",
            "data-name": "Path 6773",
            d: "M230.663,332.284c-1.839-.453-4.117,1.976-5.845,5.862a.04.04,0,0,0,.006.017q.022.078.051.154c.009.023.014.043.023.066a1.967,1.967,0,0,0,.1.208l.02.034q.047.086.1.171l.051.074c0,.006.009.011.011.017-.023.031-.046.063-.066.094s-.048.08-.071.12-.04.068-.057.1-.04.086-.06.128a.936.936,0,0,0-.043.1c-.012.034-.031.091-.046.137s-.02.063-.029.094a1.477,1.477,0,0,0-.031.154.671.671,0,0,0-.014.08,1.619,1.619,0,0,0-.014.237v2.229a1.941,1.941,0,0,0,.014.222.573.573,0,0,0,.011.068,1.473,1.473,0,0,0,.031.154.563.563,0,0,0,.02.074,1.538,1.538,0,0,0,.051.154c.009.023.014.043.023.066a1.97,1.97,0,0,0,.1.208.418.418,0,0,1,.02.037q.047.086.1.171l.051.074c0,.006.009.011.011.017-.023.031-.046.063-.066.094s-.051.083-.074.123-.04.066-.057.1-.04.086-.06.128a.936.936,0,0,0-.043.1c-.012.034-.031.091-.046.14-.009.031-.02.06-.028.091a1.382,1.382,0,0,0-.031.157.741.741,0,0,0-.014.077,1.621,1.621,0,0,0-.014.237v2.229a1.941,1.941,0,0,0,.014.222.577.577,0,0,0,.011.068,1.469,1.469,0,0,0,.031.154.566.566,0,0,0,.02.074,1.542,1.542,0,0,0,.051.154c.009.023.014.043.023.066a2.32,2.32,0,0,0,.1.211l.02.034q.047.086.1.171l.051.074c.031.046.063.088.1.134.02.026.04.051.063.077.037.046.077.088.117.134.02.023.04.046.063.068.06.063.125.125.191.185.023.023.051.043.077.066.046.04.094.083.145.123.034.029.071.054.1.083s.088.068.134.1l.12.085c.046.031.094.066.143.1s.083.057.128.083c.083.051.168.105.259.154.054.031.111.063.168.091s.088.048.134.071l.185.094.128.063.205.1a1.071,1.071,0,0,1,.1.046q.389.175.821.334a.815.815,0,0,0,.088.031l.282.1c.028.009.054.017.083.029.4.134.835.257,1.286.371a28.908,28.908,0,0,0,2.027-5.7c1.617-6.577.878-12.413-1.654-13.035Z",
            transform: "translate(-216.992 -312.21)",
            fill: "#ccc",
            opacity: "0.6"
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10955",
            "data-name": "Group 10955",
            transform: "translate(0 17.745)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6774",
              "data-name": "Path 6774",
              d: "M205.843,348.336c2.42.961,6.406-3.367,8.9-9.665s2.555-12.179.134-13.14l-2.073-.821-9.038,22.8,2.073.821Z",
              transform: "translate(-201.993 -324.579)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10953",
              "data-name": "Group 10953",
              transform: "translate(1.785 7.523)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6775",
                "data-name": "Path 6775",
                d: "M221.85,367.283l5.371,2.13c.154-.351.3-.71.45-1.078L222.28,366.2Z",
                transform: "translate(-216.704 -361.764)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6776",
                "data-name": "Path 6776",
                d: "M218.8,373.142l5.206,2.064c.3-.562.593-1.152.872-1.765l-5.354-2.121-.721,1.822Z",
                transform: "translate(-214.524 -365.424)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6777",
                "data-name": "Path 6777",
                d: "M213.046,380.28l-6.207-2.46-3.039,7.666,2.064.818C207.783,387.066,210.682,384.506,213.046,380.28Z",
                transform: "translate(-203.8 -370.071)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6778",
                "data-name": "Path 6778",
                d: "M229,351.014l5.1,2.021c.031-.131.063-.262.091-.393l-5.049-2-.148.371Z",
                transform: "translate(-221.815 -350.64)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6779",
                "data-name": "Path 6779",
                d: "M232.3,358.08l.111-.385-5.234-2.076-.148.371Z",
                transform: "translate(-220.407 -354.2)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6780",
                "data-name": "Path 6780",
                d: "M224.54,361.865l5.377,2.13c.068-.185.131-.368.194-.55l-5.357-2.124-.214.542Z",
                transform: "translate(-218.627 -358.275)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10954",
              "data-name": "Group 10954",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6781",
                "data-name": "Path 6781",
                d: "M208.228,337.534c-2.495,6.3-6.48,10.623-8.9,9.665s-2.361-6.842.134-13.137,6.48-10.623,8.9-9.665,2.361,6.842-.134,13.14Z",
                transform: "translate(-197.545 -324.261)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6782",
                "data-name": "Path 6782",
                d: "M210.007,347.22c-.117.328-.239.656-.371.986-2.495,6.3-6.48,10.623-8.9,9.665-1.505-.6-2.05-3.1-1.651-6.412-2.121,5.913-2.056,11.241.237,12.151,2.421.961,6.409-3.367,8.9-9.665a27.772,27.772,0,0,0,1.785-6.725Z",
                transform: "translate(-197.542 -340.672)",
                opacity: "0.4",
                fill: "url(#linear-gradient-14)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6783",
                "data-name": "Path 6783",
                d: "M209.175,324.728c-2.432-.747-6.315,3.53-8.764,9.708s-2.549,11.954-.265,13.078c2.432.747,6.315-3.53,8.764-9.708S211.458,325.851,209.175,324.728Zm-.81,12.861c-2.027,5.118-5.28,8.647-7.247,7.866s-1.919-5.577.108-10.694,5.28-8.647,7.247-7.866S210.392,332.471,208.365,337.589Z",
                transform: "translate(-198.226 -324.532)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6784",
                "data-name": "Path 6784",
                d: "M214.849,351.283l-.479,4.912.881.348.4-5.063a4.949,4.949,0,0,0,1.574-1.594c.043-.063.08-.125.12-.188l.787.311.65-1.636-.6-.239c.157-.351.291-.684.4-.975l.593.234.647-1.636-2.358-.935-.65,1.636,1.138.45c-.1.277-.234.619-.4.972l-1.126-.445-.647,1.636.8.319a2.2,2.2,0,0,1-1.046.679l-.676,1.212Z",
                transform: "translate(-209.571 -338.956)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6785",
                "data-name": "Path 6785",
                d: "M207.514,326.506c1.967.781,1.919,5.577-.108,10.694s-5.28,8.647-7.247,7.866-1.919-5.577.108-10.694,5.28-8.647,7.247-7.866m.838-2.121c-2.421-.961-6.409,3.367-8.9,9.665s-2.554,12.179-.134,13.137,6.409-3.367,8.9-9.665,2.555-12.179.134-13.14h0Z",
                transform: "translate(-197.538 -324.252)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6786",
                "data-name": "Path 6786",
                d: "M205.287,352.334c-1.708-.676-1.665-4.841.094-9.28s4.582-7.5,6.289-6.828,1.665,4.841-.094,9.283S206.994,353.012,205.287,352.334Zm6.244-15.752c-1.634-.647-4.331,2.281-6.013,6.526s-1.722,8.228-.088,8.875,4.331-2.281,6.013-6.526,1.722-8.228.091-8.875Z",
                transform: "translate(-202.181 -332.745)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6787",
                "data-name": "Path 6787",
                d: "M212.789,350.466l-.479,4.912.881.348.4-5.066a4.921,4.921,0,0,0,1.574-1.594l.12-.188.787.311.65-1.636-.6-.239c.157-.351.291-.684.4-.975l.593.234.647-1.636L215.4,344l-.647,1.636,1.138.45c-.1.277-.234.619-.4.972l-1.126-.445-.65,1.636.8.319a2.194,2.194,0,0,1-1.049.679l-.676,1.212Z",
                transform: "translate(-208.098 -338.37)",
                fill: "#ffc022"
              })]
            })]
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6788",
            "data-name": "Path 6788",
            d: "M333.9,371.008c4.4-.716,7.5-2.392,7.5-4.348v-2.229a2,2,0,0,1,0-2.486v-2.229a2,2,0,0,1,0-2.486V355a2,2,0,0,1,0-2.486v-.031c-2.515-.881-7.21,2.908-10.8,8.832a24.681,24.681,0,0,0-3.723,9.984q.338.026.684.043h0c.513.026,1.038.04,1.571.04.5,0,1-.014,1.485-.034h.009a28.542,28.542,0,0,0,3.045-.3l.231-.034Z",
            transform: "translate(-290.004 -326.598)",
            fill: "#ccc",
            opacity: "0.6"
          }), /*#__PURE__*/_jsxs("g", {
            id: "Group_10958",
            "data-name": "Group 10958",
            transform: "translate(47.252 25.07)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6789",
              "data-name": "Path 6789",
              d: "M374.092,374.026c-2.421.961-6.406-3.367-8.9-9.665s-2.554-12.179-.134-13.14l2.073-.821,9.038,22.8-2.073.821Z",
              transform: "translate(-363.277 -350.27)",
              fill: "#ff931e"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10956",
              "data-name": "Group 10956",
              transform: "translate(0.5 7.52)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6790",
                "data-name": "Path 6790",
                d: "M375.8,392.963l-5.371,2.13c-.154-.351-.3-.71-.45-1.078l5.391-2.135Z",
                transform: "translate(-368.569 -387.444)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6791",
                "data-name": "Path 6791",
                d: "M378.225,398.822l-5.206,2.064c-.3-.562-.593-1.152-.87-1.765L377.5,397Z",
                transform: "translate(-370.12 -391.104)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6792",
                "data-name": "Path 6792",
                d: "M376.02,405.97l6.207-2.46,3.039,7.666-2.064.818C381.283,412.756,378.383,410.2,376.02,405.97Z",
                transform: "translate(-372.887 -395.758)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6793",
                "data-name": "Path 6793",
                d: "M370.225,376.693l-5.1,2.021c-.031-.131-.063-.262-.091-.393l5.049-2,.148.371Z",
                transform: "translate(-365.03 -376.32)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6794",
                "data-name": "Path 6794",
                d: "M366.451,383.77l-.111-.385,5.234-2.076.148.371-5.271,2.09Z",
                transform: "translate(-365.967 -379.887)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6795",
                "data-name": "Path 6795",
                d: "M373.751,387.555l-5.377,2.13c-.068-.185-.131-.368-.194-.55l5.357-2.124.214.542Z",
                transform: "translate(-367.282 -383.962)",
                fill: "#d17918"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              id: "Group_10957",
              "data-name": "Group 10957",
              transform: "translate(2.073)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_6796",
                "data-name": "Path 6796",
                d: "M372.458,363.214c2.495,6.3,6.48,10.623,8.9,9.665s2.361-6.842-.134-13.137-6.48-10.623-8.9-9.665-2.361,6.842.134,13.14Z",
                transform: "translate(-370.547 -349.944)",
                fill: "#ff931e"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6797",
                "data-name": "Path 6797",
                d: "M370.99,372.9c.117.328.239.656.371.986,2.495,6.3,6.48,10.623,8.9,9.665,1.505-.6,2.05-3.1,1.651-6.412,2.121,5.913,2.056,11.242-.237,12.151-2.421.961-6.406-3.367-8.9-9.665A27.775,27.775,0,0,1,370.99,372.9Z",
                transform: "translate(-370.864 -366.355)",
                opacity: "0.4",
                fill: "url(#linear-gradient-15)"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6798",
                "data-name": "Path 6798",
                d: "M372.463,363.485c2.449,6.178,6.332,10.455,8.764,9.708,2.284-1.123,2.184-6.9-.265-13.078s-6.332-10.455-8.764-9.708C369.915,351.531,370.017,357.307,372.463,363.485Zm.433-10.911c1.967-.781,5.217,2.748,7.247,7.866s2.078,9.916.108,10.694-5.22-2.748-7.247-7.866-2.075-9.915-.1-10.693Z",
                transform: "translate(-370.552 -350.215)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6799",
                "data-name": "Path 6799",
                d: "M383.746,376.973l.479,4.912-.881.348-.4-5.063a4.952,4.952,0,0,1-1.574-1.594c-.043-.063-.08-.125-.12-.188l-.787.311-.65-1.636.6-.239c-.157-.351-.291-.684-.4-.975l-.593.234-.65-1.636,2.358-.935.65,1.636-1.138.45c.1.277.234.619.4.972l1.126-.445.65,1.636-.8.319a2.2,2.2,0,0,0,1.046.679l.676,1.212Z",
                transform: "translate(-376.433 -364.647)",
                fill: "#d17918"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6800",
                "data-name": "Path 6800",
                d: "M373.165,352.2c1.967-.781,5.22,2.748,7.247,7.866s2.076,9.916.108,10.694-5.22-2.748-7.247-7.866-2.078-9.916-.108-10.694m-.841-2.121c-2.421.961-2.361,6.842.134,13.14s6.48,10.623,8.9,9.665,2.361-6.842-.134-13.137-6.48-10.623-8.9-9.665h0Z",
                transform: "translate(-370.547 -349.951)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6801",
                "data-name": "Path 6801",
                d: "M378.381,371.2c-1.759-4.442-1.8-8.6-.094-9.283s4.53,2.386,6.289,6.828,1.8,8.6.094,9.28S380.14,375.638,378.381,371.2Zm.137-.054c1.682,4.245,4.379,7.173,6.013,6.526s1.594-4.627-.088-8.875-4.379-7.173-6.013-6.526-1.594,4.627.091,8.875Z",
                transform: "translate(-375.184 -358.436)",
                fill: "#ffc022"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_6802",
                "data-name": "Path 6802",
                d: "M385.824,376.146l.479,4.912-.881.348-.4-5.066a4.922,4.922,0,0,1-1.574-1.594l-.12-.188-.787.311-.65-1.636.6-.239c-.157-.351-.291-.684-.4-.975l-.593.234-.647-1.636,2.358-.935.647,1.636-1.138.45c.1.277.234.619.4.972l1.126-.445.65,1.636-.8.319a2.2,2.2,0,0,0,1.049.679l.676,1.212Z",
                transform: "translate(-377.92 -364.053)",
                fill: "#ffc022"
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6803",
          "data-name": "Path 6803",
          d: "M236.177,339.646l-.5-1.266-.5,1.266-1.269.5,1.269.5.5,1.269.5-1.269,1.269-.5Z",
          transform: "translate(-223.54 -316.607)",
          fill: "#fff"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6804",
          "data-name": "Path 6804",
          d: "M362.409,334.939l-.5-1.269-.5,1.269-1.269.5,1.269.5.5,1.269.5-1.269,1.266-.5Z",
          transform: "translate(-313.782 -313.24)",
          fill: "#fff"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6805",
          "data-name": "Path 6805",
          d: "M403.787,285.359l-.5-1.269-.5,1.269-1.266.5,1.266.5.5,1.269.5-1.269,1.269-.5Z",
          transform: "translate(-343.365 -277.795)",
          fill: "#fff"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6806",
          "data-name": "Path 6806",
          d: "M297.789,367.2l-.5-1.269-.5,1.269-1.269.5,1.269.5.5,1.269.5-1.269,1.266-.5Z",
          transform: "translate(-267.585 -336.302)",
          fill: "#fff"
        })]
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6807",
        "data-name": "Path 6807",
        d: "M217.162,156.18s-6.785,4.955-8.912,8.738c0,0,9.066-6.72,13.913-8.738Z",
        transform: "translate(-172.63 -130.892)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6808",
        "data-name": "Path 6808",
        d: "M246.66,156.18a19.219,19.219,0,0,1,7.786,8.738,18.818,18.818,0,0,0-3.053-8.738Z",
        transform: "translate(-200.089 -130.892)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6809",
        "data-name": "Path 6809",
        d: "M283.08,199.87a96.138,96.138,0,0,1,7.082,18.01S290.7,207.214,283.08,199.87Z",
        transform: "translate(-226.126 -162.126)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6810",
        "data-name": "Path 6810",
        d: "M304.41,203.7a96.139,96.139,0,0,1,7.082,18.01S312.034,211.044,304.41,203.7Z",
        transform: "translate(-241.374 -164.864)",
        fill: "#e8c47b"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6811",
        "data-name": "Path 6811",
        d: "M279.14,211.854a41.054,41.054,0,0,1,14.7.55A19.059,19.059,0,0,0,279.14,211.854Z",
        transform: "translate(-223.309 -169.804)",
        fill: "#e8c47b"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6812",
        "data-name": "Path 6812",
        d: "M285.04,226.4a41.053,41.053,0,0,1,14.705.55,19.059,19.059,0,0,0-14.705-.55Z",
        transform: "translate(-227.527 -180.206)",
        fill: "#e8c47b"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group_10961",
        "data-name": "Group 10961",
        transform: "translate(55.834 40.838)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Path_6813",
          "data-name": "Path 6813",
          d: "M285.04,226.453a42.324,42.324,0,0,1,6.124-.425c-.111-.265-.225-.53-.345-.8a17.292,17.292,0,0,0-5.779,1.226Z",
          transform: "translate(-283.361 -221.093)",
          fill: "#dab873"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6814",
          "data-name": "Path 6814",
          d: "M285.04,211.51c-.131-.262-.265-.525-.4-.79a17.252,17.252,0,0,0-5.488,1.212,42.432,42.432,0,0,1,5.89-.425Z",
          transform: "translate(-279.15 -210.72)",
          fill: "#dab873"
        })]
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6815",
        "data-name": "Path 6815",
        d: "M212.2,79.42l9.825,18.375V78.2l-.567.231c-.034.014-.068.029-.1.04-.191.077-.385.151-.576.225l-.023.009c-.2.074-.4.148-.6.22l-.123.043c-.157.054-.314.108-.47.16l-.16.051c-.18.057-.362.111-.542.163l-.048.014c-.194.054-.385.1-.576.148l-.157.034c-.145.031-.288.06-.43.088-.054.011-.111.02-.165.029-.188.031-.376.06-.562.077a15.78,15.78,0,0,1-4.721-.314Z",
        transform: "translate(-175.454 -75.144)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6816",
        "data-name": "Path 6816",
        d: "M201.519,79.772c-.205-.057-.433-.128-.679-.2l8.151,12.493-5.961-11.9c-.513-.123-1.018-.257-1.511-.393Z",
        transform: "translate(-167.332 -76.123)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6817",
        "data-name": "Path 6817",
        d: "M295.316,70.645c1.52-1.16,1.83-2.848-.881-3.125-4.75-.485-7.9,3.609-12.621,3.943L270.94,92.769h4.219l20.154-22.121Z",
        transform: "translate(-217.447 -67.48)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6818",
        "data-name": "Path 6818",
        d: "M275.54,93.109l8.048-16.077A7.319,7.319,0,0,1,279.8,75.31l-4.257,17.8Z",
        transform: "translate(-220.735 -73.078)",
        fill: "#dab873"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6819",
        "data-name": "Path 6819",
        d: "M190.7,238.346a15.562,15.562,0,1,1,15.934-15.558A15.767,15.767,0,0,1,190.7,238.346Zm0-29.123a13.567,13.567,0,1,0,13.939,13.562A13.769,13.769,0,0,0,190.7,209.223Z",
        transform: "translate(-148.695 -167.387)",
        fill: "#534741"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6820",
        "data-name": "Path 6820",
        d: "M210.8,238.876l5.987,8.011h4.16l-6.574-8.2a8.436,8.436,0,0,0,3.846-3.484c.068-.123.125-.245.188-.371h3.709V231.86h-2.851a10.6,10.6,0,0,0,.048-1.776h2.8V227.11H210.98v2.974h5.377a7.1,7.1,0,0,1-.063,1.776H210.98v2.974h3.795a7.12,7.12,0,0,1-3.179,1.719l-.8,2.324Z",
        transform: "translate(-174.453 -181.599)",
        fill: "#534741"
      })]
    }), /*#__PURE__*/_jsxs("g", {
      id: "Group_10964",
      "data-name": "Group 10964",
      transform: "translate(38.551 20.547)",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_6821",
        "data-name": "Path 6821",
        d: "M241.7,143.523a1.158,1.158,0,0,1-.277-.031c-7.433-1.642-21.177,0-21.317.02a1.479,1.479,0,0,1-1.571-1.423,1.569,1.569,0,0,1,1.263-1.768c.582-.071,14.312-1.716,22.172.02a1.6,1.6,0,0,1,1.123,1.882,1.481,1.481,0,0,1-1.4,1.294Z",
        transform: "translate(-218.53 -139.548)",
        fill: "#ff931e"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group_10963",
        "data-name": "Group 10963",
        transform: "translate(0.91 0.003)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Path_6822",
          "data-name": "Path 6822",
          d: "M251.484,139.76l-.707.026a10.338,10.338,0,0,0-1.317,3.282l.6-.031a9.691,9.691,0,0,1,1.424-3.277Z",
          transform: "translate(-241.551 -139.703)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6823",
          "data-name": "Path 6823",
          d: "M237.516,140.49l-.707.051a10.542,10.542,0,0,0-1.229,3.321c.191-.017.391-.031.593-.048a9.987,9.987,0,0,1,1.34-3.321Z",
          transform: "translate(-231.629 -140.225)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6824",
          "data-name": "Path 6824",
          d: "M244.517,140.06c-.24.011-.476.026-.707.04a10.408,10.408,0,0,0-1.28,3.3l.593-.04a9.767,9.767,0,0,1,1.394-3.3Z",
          transform: "translate(-236.597 -139.917)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6825",
          "data-name": "Path 6825",
          d: "M230.463,141.05c-.245.02-.479.043-.7.063a10.629,10.629,0,0,0-1.169,3.336c.182-.017.379-.037.6-.06A10.048,10.048,0,0,1,230.463,141.05Z",
          transform: "translate(-226.631 -140.625)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6826",
          "data-name": "Path 6826",
          d: "M222.783,141.794a10.737,10.737,0,0,0-1.063,3.167,1.256,1.256,0,0,0,.565.108,10.125,10.125,0,0,1,1.2-3.35C223.217,141.749,222.98,141.771,222.783,141.794Z",
          transform: "translate(-221.72 -141.104)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6827",
          "data-name": "Path 6827",
          d: "M292.179,141.277c-.2-.034-.4-.066-.61-.1a10.565,10.565,0,0,0-1.129,3.079c.191.023.382.048.567.074a10.078,10.078,0,0,1,1.169-3.056Z",
          transform: "translate(-270.848 -140.718)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6828",
          "data-name": "Path 6828",
          d: "M298.153,142.319l-.034-.009a10.694,10.694,0,0,0-1.009,3.053c.168.031.334.066.493.1a.5.5,0,0,1,.066.009,10.358,10.358,0,0,1,.975-2.931,1.32,1.32,0,0,0-.493-.225Z",
          transform: "translate(-275.616 -141.526)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6829",
          "data-name": "Path 6829",
          d: "M278.9,139.953l-.659-.043a10.422,10.422,0,0,0-1.28,3.153c.2.006.391.014.584.023a9.753,9.753,0,0,1,1.354-3.136Z",
          transform: "translate(-261.211 -139.81)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6830",
          "data-name": "Path 6830",
          d: "M285.583,140.486c-.211-.023-.422-.046-.636-.066a10.43,10.43,0,0,0-1.217,3.116c.194.014.385.029.576.046a9.916,9.916,0,0,1,1.274-3.093Z",
          transform: "translate(-266.051 -140.175)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6831",
          "data-name": "Path 6831",
          d: "M272.136,139.67c-.225-.009-.45-.014-.676-.02a10.219,10.219,0,0,0-1.32,3.19c.2,0,.393,0,.59.006a9.751,9.751,0,0,1,1.406-3.176Z",
          transform: "translate(-256.335 -139.624)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6832",
          "data-name": "Path 6832",
          d: "M264.627,139.56a10.191,10.191,0,0,0-1.337,3.224l.593-.009a9.654,9.654,0,0,1,1.434-3.213h-.69Z",
          transform: "translate(-251.438 -139.56)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6833",
          "data-name": "Path 6833",
          d: "M258.426,139.59l-.7.011a10.263,10.263,0,0,0-1.337,3.256l.6-.02a9.665,9.665,0,0,1,1.437-3.247Z",
          transform: "translate(-246.506 -139.581)",
          fill: "#bf6e17"
        })]
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6834",
        "data-name": "Path 6834",
        d: "M241.7,146.381a1.159,1.159,0,0,1-.277-.031c-7.433-1.642-21.177,0-21.317.02a1.412,1.412,0,0,1-1.443-.909,1.747,1.747,0,0,0-.128.855,1.479,1.479,0,0,0,1.571,1.423c.137-.017,13.882-1.662,21.317-.02a1.328,1.328,0,0,0,.277.031,1.481,1.481,0,0,0,1.4-1.294,1.785,1.785,0,0,0-.114-.992,1.425,1.425,0,0,1-1.283.921Z",
        transform: "translate(-218.528 -143.775)",
        fill: "#b3b3b3",
        opacity: "0.8"
      })]
    }), /*#__PURE__*/_jsxs("g", {
      id: "Group_10966",
      "data-name": "Group 10966",
      transform: "translate(38.551 23.768)",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_6835",
        "data-name": "Path 6835",
        d: "M241.7,154.823a1.159,1.159,0,0,1-.277-.031c-7.433-1.642-21.177,0-21.317.02a1.479,1.479,0,0,1-1.571-1.423,1.569,1.569,0,0,1,1.263-1.768c.582-.071,14.312-1.716,22.172.02a1.6,1.6,0,0,1,1.123,1.882,1.481,1.481,0,0,1-1.4,1.294Z",
        transform: "translate(-218.53 -150.848)",
        fill: "#ff931e"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group_10965",
        "data-name": "Group 10965",
        transform: "translate(0.91 0.003)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Path_6836",
          "data-name": "Path 6836",
          d: "M251.484,151.06l-.707.026a10.338,10.338,0,0,0-1.317,3.282l.6-.031a9.69,9.69,0,0,1,1.424-3.277Z",
          transform: "translate(-241.551 -151.003)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6837",
          "data-name": "Path 6837",
          d: "M237.516,151.8l-.707.051a10.542,10.542,0,0,0-1.229,3.321c.191-.017.391-.031.593-.048a9.987,9.987,0,0,1,1.34-3.321Z",
          transform: "translate(-231.629 -151.532)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6838",
          "data-name": "Path 6838",
          d: "M244.517,151.37c-.24.011-.476.026-.707.04a10.408,10.408,0,0,0-1.28,3.3l.593-.04a9.767,9.767,0,0,1,1.394-3.3Z",
          transform: "translate(-236.597 -151.225)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6839",
          "data-name": "Path 6839",
          d: "M230.463,152.35c-.245.02-.479.043-.7.063a10.629,10.629,0,0,0-1.169,3.336c.182-.017.379-.037.6-.06a10.048,10.048,0,0,1,1.269-3.339Z",
          transform: "translate(-226.631 -151.925)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6840",
          "data-name": "Path 6840",
          d: "M222.783,153.1a10.736,10.736,0,0,0-1.063,3.167,1.256,1.256,0,0,0,.565.108,10.125,10.125,0,0,1,1.2-3.35C223.217,153.059,222.98,153.081,222.783,153.1Z",
          transform: "translate(-221.72 -152.411)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6841",
          "data-name": "Path 6841",
          d: "M292.179,152.587c-.2-.034-.4-.066-.61-.1a10.565,10.565,0,0,0-1.129,3.079c.191.023.382.048.567.074a10.078,10.078,0,0,1,1.169-3.056Z",
          transform: "translate(-270.848 -152.025)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6842",
          "data-name": "Path 6842",
          d: "M298.153,153.619l-.034-.009a10.694,10.694,0,0,0-1.009,3.053c.168.031.334.066.493.1a.5.5,0,0,1,.066.009,10.357,10.357,0,0,1,.975-2.931,1.32,1.32,0,0,0-.493-.225Z",
          transform: "translate(-275.616 -152.826)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6843",
          "data-name": "Path 6843",
          d: "M278.9,151.263l-.659-.043a10.422,10.422,0,0,0-1.28,3.153c.2.006.391.014.584.023a9.752,9.752,0,0,1,1.354-3.136Z",
          transform: "translate(-261.211 -151.117)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6844",
          "data-name": "Path 6844",
          d: "M285.583,151.786c-.211-.023-.422-.046-.636-.066a10.43,10.43,0,0,0-1.217,3.116c.194.014.385.029.576.046a9.916,9.916,0,0,1,1.274-3.093Z",
          transform: "translate(-266.051 -151.475)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6845",
          "data-name": "Path 6845",
          d: "M272.136,150.97c-.225-.009-.45-.014-.676-.02a10.218,10.218,0,0,0-1.32,3.19c.2,0,.393,0,.59.006a9.751,9.751,0,0,1,1.406-3.176Z",
          transform: "translate(-256.335 -150.924)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6846",
          "data-name": "Path 6846",
          d: "M264.627,150.86a10.191,10.191,0,0,0-1.337,3.224l.593-.009a9.653,9.653,0,0,1,1.434-3.213h-.69Z",
          transform: "translate(-251.438 -150.86)",
          fill: "#bf6e17"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_6847",
          "data-name": "Path 6847",
          d: "M258.426,150.89l-.7.011a10.263,10.263,0,0,0-1.337,3.256l.6-.02a9.665,9.665,0,0,1,1.437-3.247Z",
          transform: "translate(-246.506 -150.881)",
          fill: "#bf6e17"
        })]
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_6848",
        "data-name": "Path 6848",
        d: "M241.7,157.681a1.16,1.16,0,0,1-.277-.031c-7.433-1.642-21.177,0-21.317.02a1.412,1.412,0,0,1-1.443-.909,1.747,1.747,0,0,0-.128.855,1.479,1.479,0,0,0,1.571,1.423c.137-.017,13.882-1.662,21.317-.02a1.327,1.327,0,0,0,.277.031,1.481,1.481,0,0,0,1.4-1.294,1.785,1.785,0,0,0-.114-.992,1.425,1.425,0,0,1-1.283.921Z",
        transform: "translate(-218.528 -155.074)",
        fill: "#b3b3b3",
        opacity: "0.8"
      })]
    })]
  })]
});
export var arrowSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 25 25",
  children: /*#__PURE__*/_jsxs("g", {
    id: "Group_3173",
    "data-name": "Group 3173",
    transform: "translate(-3107.992 -5636.5)",
    children: [/*#__PURE__*/_jsx("rect", {
      id: "Rectangle_533",
      "data-name": "Rectangle 533",
      width: "25",
      height: "25",
      rx: "2",
      transform: "translate(3107.992 5636.5)",
      fill: "#dd883d"
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_3454",
      "data-name": "Path 3454",
      d: "M3117.5,5654.578l5.976-5.976-5.976-5.18",
      fill: "none",
      stroke: "#fff",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    })]
  })
});
export var giftSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg"
  // width="60.5"
  // height="52.996"
  ,
  width: "50.5",
  height: "42.996",
  viewBox: "0 0 60.5 52.996",
  children: /*#__PURE__*/_jsxs("g", {
    id: "gift",
    transform: "translate(0 -31.753)",
    children: [/*#__PURE__*/_jsxs("g", {
      id: "Group_11886",
      "data-name": "Group 11886",
      transform: "translate(1.182 32.939)",
      children: [/*#__PURE__*/_jsxs("g", {
        id: "Group_11874",
        "data-name": "Group 11874",
        transform: "translate(4.28 19.575)",
        children: [/*#__PURE__*/_jsx("g", {
          id: "Group_11872",
          "data-name": "Group 11872",
          transform: "translate(0)",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_7474",
            "data-name": "Path 7474",
            d: "M90.268,238.737H51.749a5.529,5.529,0,0,1-5.529-5.529V207.447H95.8v25.761A5.529,5.529,0,0,1,90.268,238.737Z",
            transform: "translate(-46.22 -207.447)",
            fill: "#fd7da0"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "Group_11873",
          "data-name": "Group 11873",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_7475",
            "data-name": "Path 7475",
            d: "M59.882,207.447H46.219v25.761a5.529,5.529,0,0,0,5.529,5.529H77.8A37.33,37.33,0,0,1,59.882,207.447Z",
            transform: "translate(-46.219 -207.447)",
            fill: "#db4b86"
          })
        })]
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_11876",
        "data-name": "Group 11876",
        transform: "translate(0 10.556)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_11875",
          "data-name": "Group 11875",
          children: /*#__PURE__*/_jsx("rect", {
            id: "Rectangle_17310",
            "data-name": "Rectangle 17310",
            width: "58.137",
            height: "9.019",
            fill: "#fd7da0"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_11881",
        "data-name": "Group 11881",
        transform: "translate(7.825 0)",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Group_11880",
          "data-name": "Group 11880",
          children: [/*#__PURE__*/_jsx("g", {
            id: "Group_11877",
            "data-name": "Group 11877",
            children: /*#__PURE__*/_jsx("path", {
              id: "Path_7476",
              "data-name": "Path 7476",
              d: "M92.552,52.341H76.221l2.716-6.835a5.884,5.884,0,0,1,7.905-3.192l.814.371a8.368,8.368,0,0,1,4.9,7.619Z",
              transform: "translate(-76.221 -41.784)",
              fill: "#fd8f01"
            })
          }), /*#__PURE__*/_jsx("g", {
            id: "Group_11878",
            "data-name": "Group 11878",
            transform: "translate(26.156)",
            children: /*#__PURE__*/_jsx("path", {
              id: "Path_7477",
              "data-name": "Path 7477",
              d: "M297.573,52.341H313.9l-2.716-6.835a5.884,5.884,0,0,0-7.905-3.192l-.814.371a8.368,8.368,0,0,0-4.9,7.619Z",
              transform: "translate(-297.573 -41.784)",
              fill: "#fdcb50"
            })
          }), /*#__PURE__*/_jsx("g", {
            id: "Group_11879",
            "data-name": "Group 11879",
            transform: "translate(16.331 3.128)",
            children: /*#__PURE__*/_jsx("path", {
              id: "Path_7478",
              "data-name": "Path 7478",
              d: "M224.251,75.685h-9.825V73.169a4.912,4.912,0,0,1,4.912-4.912h0a4.912,4.912,0,0,1,4.912,4.912v2.516Z",
              transform: "translate(-214.426 -68.257)",
              fill: "#67ccd1"
            })
          })]
        })
      }), /*#__PURE__*/_jsx("g", {
        id: "Group_11882",
        "data-name": "Group 11882",
        transform: "translate(23.382 10.556)",
        children: /*#__PURE__*/_jsx("rect", {
          id: "Rectangle_17311",
          "data-name": "Rectangle 17311",
          width: "11.373",
          height: "9.019",
          fill: "#fff"
        })
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group_11885",
        "data-name": "Group 11885",
        transform: "translate(23.382 19.575)",
        children: [/*#__PURE__*/_jsx("g", {
          id: "Group_11883",
          "data-name": "Group 11883",
          children: /*#__PURE__*/_jsx("rect", {
            id: "Rectangle_17312",
            "data-name": "Rectangle 17312",
            width: "11.373",
            height: "31.29",
            fill: "#fff"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "Group_11884",
          "data-name": "Group 11884",
          transform: "translate(0 18.814)",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_7479",
            "data-name": "Path 7479",
            d: "M207.878,366.665v12.476h11.373v-.7A37.55,37.55,0,0,1,207.878,366.665Z",
            transform: "translate(-207.878 -366.665)",
            fill: "#d2dcfd"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_7480",
      "data-name": "Path 7480",
      d: "M59.318,42.314h-7.03a1.19,1.19,0,0,0-.04-.119l-2.372-5.97a7.066,7.066,0,0,0-9.493-3.831l-.814.371A9.544,9.544,0,0,0,35,37.167a6.087,6.087,0,0,0-9.5,0,9.544,9.544,0,0,0-4.568-4.4l-.814-.371a7.066,7.066,0,0,0-9.493,3.831L8.2,42.314H1.182A1.182,1.182,0,0,0,0,43.5v9.019A1.182,1.182,0,0,0,1.182,53.7h3.1V78.038a6.719,6.719,0,0,0,6.711,6.711H49.509a6.719,6.719,0,0,0,6.711-6.711V53.7h3.1A1.182,1.182,0,0,0,60.5,52.514V43.5A1.182,1.182,0,0,0,59.318,42.314Zm-18.771-7.4.814-.371A4.7,4.7,0,0,1,47.68,37.1l2.073,5.217H38.6l3.733-2.207a1.182,1.182,0,0,0-1.2-2.034l-4.762,2.815A7.2,7.2,0,0,1,40.548,34.915ZM26.519,40.979a3.731,3.731,0,0,1,7.462,0v1.334H26.519ZM12.82,37.1a4.7,4.7,0,0,1,6.318-2.553l.814.371a7.2,7.2,0,0,1,4.181,5.973l-4.762-2.815a1.182,1.182,0,0,0-1.2,2.034L21.9,42.314H10.747ZM53.857,78.038a4.353,4.353,0,0,1-4.348,4.348H10.991a4.353,4.353,0,0,1-4.348-4.348V53.7H53.857Zm4.28-26.706H2.363V44.677H58.137Z",
      fill: "#052a75"
    })]
  })
});
export var bigRewardCoinSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29.877",
  height: "30",
  viewBox: "0 0 29.877 30",
  children: /*#__PURE__*/_jsx("g", {
    id: "Currency",
    transform: "translate(-11.11 0.13)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Dollar",
      transform: "translate(11.11 -0.13)",
      children: [/*#__PURE__*/_jsxs("g", {
        id: "Coin",
        transform: "translate(0 0)",
        children: [/*#__PURE__*/_jsxs("g", {
          id: "Bottom",
          children: [/*#__PURE__*/_jsx("ellipse", {
            id: "Ellipse_1797",
            "data-name": "Ellipse 1797",
            cx: "14.5",
            cy: "15",
            rx: "14.5",
            ry: "15",
            transform: "translate(0.877 0)",
            fill: "#e88102"
          }), /*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1798",
            "data-name": "Ellipse 1798",
            cx: "14.551",
            cy: "14.551",
            r: "14.551",
            transform: "translate(0 0.177)",
            fill: "#fdd835"
          })]
        }), /*#__PURE__*/_jsxs("g", {
          id: "Shade",
          transform: "translate(0 0.177)",
          children: [/*#__PURE__*/_jsx("path", {
            id: "Path_7320",
            "data-name": "Path 7320",
            d: "M34.517,1.77,15.364,20.917a14.4,14.4,0,0,1-1.164-4.74L29.771.6a14.626,14.626,0,0,1,4.746,1.17Z",
            transform: "translate(-14.158 -0.564)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7321",
            "data-name": "Path 7321",
            d: "M104.65,71.33,84.83,91.15a14.525,14.525,0,0,1-3.33-2.58L102.075,68A14.539,14.539,0,0,1,104.65,71.33Z",
            transform: "translate(-77.42 -63.92)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7322",
            "data-name": "Path 7322",
            d: "M78.828,44.706,58.306,65.228c-.318-.372-.624-.762-.906-1.164L77.663,43.8c.4.282.792.588,1.164.906Z",
            transform: "translate(-54.766 -41.172)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7323",
            "data-name": "Path 7323",
            d: "M188.691,157.466l-17.725,17.725a15.319,15.319,0,0,1-1.566-.5L188.193,155.9A15.343,15.343,0,0,1,188.691,157.466Z",
            transform: "translate(-160.045 -146.545)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7324",
            "data-name": "Path 7324",
            d: "M42.6,14.551c0,.1,0,.2-.006.3a14.548,14.548,0,0,0-29.09,0c0-.1-.006-.2-.006-.3a14.551,14.551,0,0,1,29.1,0Z",
            transform: "translate(-13.5)",
            fill: "#fff",
            opacity: "0.5"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7325",
            "data-name": "Path 7325",
            d: "M136.691,131.741A11.4,11.4,0,0,1,116.5,139a11.4,11.4,0,0,0,17.161-15A11.375,11.375,0,0,1,136.691,131.741Z",
            transform: "translate(-110.32 -116.559)",
            fill: "#fff",
            opacity: "0.5"
          })]
        }), /*#__PURE__*/_jsxs("g", {
          id: "Top",
          transform: "translate(3.632 3.832)",
          children: [/*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1799",
            "data-name": "Ellipse 1799",
            cx: "11",
            cy: "11",
            r: "11",
            transform: "translate(0.245 0.168)",
            fill: "#f39e09"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_7326",
            "data-name": "Path 7326",
            d: "M85.259,58.806A10.958,10.958,0,0,0,69.806,74.259,10.957,10.957,0,1,1,85.259,58.806Z",
            transform: "translate(-66 -55)",
            fill: "#e88102"
          })]
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icon",
        transform: "translate(4.32 4.617)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Path_7337",
          "data-name": "Path 7337",
          d: "M7.235-176.218v-1.55l1.381-.27v-9.269l-1.381-.27v-1.561H13.36a6.4,6.4,0,0,1,2.555.463,3.643,3.643,0,0,1,1.639,1.324,3.649,3.649,0,0,1,.571,2.064,3.718,3.718,0,0,1-.569,2.034,3.95,3.95,0,0,1-1.578,1.413,5.1,5.1,0,0,1-2.333.52l-2.438,0v3.279l1.381.27v1.55Zm8.314,0L13.374-181.8l2.339-.576,1.883,4.349,1.1.253v1.555Zm-4.342-7.1h2.108a2.53,2.53,0,0,0,1.675-.474,1.711,1.711,0,0,0,.556-1.378,1.914,1.914,0,0,0-.551-1.437,2.253,2.253,0,0,0-1.634-.537H11.207Z",
          transform: "translate(-2.486 193.145)",
          fill: "#fdd835"
        }), /*#__PURE__*/_jsx("g", {
          id: "Shade-2",
          children: /*#__PURE__*/_jsx("path", {
            id: "Path_7336",
            "data-name": "Path 7336",
            d: "M105.711,78.906A27.253,27.253,0,0,0,89.5,94.423c-.252-.186-.5-.378-.738-.588A11.4,11.4,0,0,1,104.835,77.76,12.319,12.319,0,0,1,105.711,78.906Z",
            transform: "translate(-86 -75)",
            fill: "#fff",
            opacity: "0.25"
          })
        })]
      })]
    })
  })
});
export var smallRewardCoinSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15.877",
  height: "16",
  viewBox: "0 0 15.877 16",
  children: /*#__PURE__*/_jsxs("g", {
    id: "Dollar",
    transform: "translate(0)",
    children: [/*#__PURE__*/_jsxs("g", {
      id: "Coin",
      children: [/*#__PURE__*/_jsxs("g", {
        id: "Bottom",
        children: [/*#__PURE__*/_jsx("ellipse", {
          id: "Ellipse_1797",
          "data-name": "Ellipse 1797",
          cx: "7.5",
          cy: "8",
          rx: "7.5",
          ry: "8",
          transform: "translate(0.877)",
          fill: "#e88102"
        }), /*#__PURE__*/_jsx("circle", {
          id: "Ellipse_1798",
          "data-name": "Ellipse 1798",
          cx: "7.709",
          cy: "7.709",
          r: "7.709",
          transform: "translate(0 0.201)",
          fill: "#fdd835"
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Shade",
        transform: "translate(0 0.201)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Path_7320",
          "data-name": "Path 7320",
          d: "M24.963,1.22,14.817,11.364A7.627,7.627,0,0,1,14.2,8.852L22.449.6a7.748,7.748,0,0,1,2.514.62Z",
          transform: "translate(-14.178 -0.581)",
          fill: "#fff",
          opacity: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_7321",
          "data-name": "Path 7321",
          d: "M93.764,69.764l-10.5,10.5A7.694,7.694,0,0,1,81.5,78.9L92.4,68A7.7,7.7,0,0,1,93.764,69.764Z",
          transform: "translate(-79.338 -65.838)",
          fill: "#fff",
          opacity: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_7322",
          "data-name": "Path 7322",
          d: "M68.752,44.28,57.88,55.152c-.168-.2-.331-.4-.48-.617L68.135,43.8C68.348,43.949,68.555,44.112,68.752,44.28Z",
          transform: "translate(-56.004 -42.408)",
          fill: "#fff",
          opacity: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_7323",
          "data-name": "Path 7323",
          d: "M179.62,156.73l-9.39,9.39a8.119,8.119,0,0,1-.83-.264l9.956-9.956A8.127,8.127,0,0,1,179.62,156.73Z",
          transform: "translate(-164.444 -150.944)",
          fill: "#fff",
          opacity: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_7324",
          "data-name": "Path 7324",
          d: "M28.917,7.709c0,.054,0,.1,0,.159a7.707,7.707,0,0,0-15.411,0c0-.054,0-.1,0-.159a7.709,7.709,0,0,1,15.417,0Z",
          transform: "translate(-13.5)",
          fill: "#fff",
          opacity: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_7325",
          "data-name": "Path 7325",
          d: "M127.2,128.1a6.04,6.04,0,0,1-10.7,3.846A6.04,6.04,0,0,0,125.591,124,6.026,6.026,0,0,1,127.2,128.1Z",
          transform: "translate(-113.226 -120.058)",
          fill: "#fff",
          opacity: "0.5"
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Top",
        transform: "translate(1.877 2.138)",
        children: [/*#__PURE__*/_jsx("ellipse", {
          id: "Ellipse_1799",
          "data-name": "Ellipse 1799",
          cx: "6",
          cy: "5.5",
          rx: "6",
          ry: "5.5",
          transform: "translate(0 0.863)",
          fill: "#f39e09"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_7326",
          "data-name": "Path 7326",
          d: "M76.2,57.016A5.805,5.805,0,0,0,68.016,65.2,5.8,5.8,0,1,1,76.2,57.016Z",
          transform: "translate(-65.953 -55)",
          fill: "#e88102"
        })]
      })]
    }), /*#__PURE__*/_jsxs("g", {
      id: "Icon",
      transform: "translate(2.289 2.553)",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_7337",
        "data-name": "Path 7337",
        d: "M7.235-182.294v-.821l.731-.143v-4.91l-.731-.143v-.827H10.48a3.391,3.391,0,0,1,1.354.245,1.93,1.93,0,0,1,.868.7A1.933,1.933,0,0,1,13-187.1a1.97,1.97,0,0,1-.3,1.077,2.093,2.093,0,0,1-.836.749,2.7,2.7,0,0,1-1.236.275l-1.292,0v1.737l.731.143v.821Zm4.4,0-1.152-2.956,1.239-.305,1,2.3.582.134v.824Zm-2.3-3.761h1.117a1.34,1.34,0,0,0,.888-.251.906.906,0,0,0,.295-.73,1.014,1.014,0,0,0-.292-.761,1.194,1.194,0,0,0-.866-.284H9.339Z",
        transform: "translate(-4.719 191.261)",
        fill: "#fdd835"
      }), /*#__PURE__*/_jsx("g", {
        id: "Shade-2",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_7336",
          "data-name": "Path 7336",
          d: "M96.442,77.069a14.438,14.438,0,0,0-8.589,8.22c-.134-.1-.264-.2-.391-.312a6.039,6.039,0,0,1,8.516-8.516A6.524,6.524,0,0,1,96.442,77.069Z",
          transform: "translate(-86 -75)",
          fill: "#fff",
          opacity: "0.25"
        })
      })]
    })]
  })
});
export var verifiedSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.74",
  height: "16.148",
  viewBox: "0 0 13.74 16.148",
  children: /*#__PURE__*/_jsxs("g", {
    id: "Group_11922",
    "data-name": "Group 11922",
    transform: "translate(-1252 -347.094)",
    children: [/*#__PURE__*/_jsxs("g", {
      id: "verified-shield",
      transform: "translate(1252 347.094)",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_7483",
        "data-name": "Path 7483",
        d: "M16.9,4.954c-1.8-.128-3.445-1.225-5.046-2.294-.283-.188-.558-.37-.834-.552a.667.667,0,0,0-.781.04C8.594,3.446,6.616,4.8,4.416,4.954a.676.676,0,0,0-.626.673V7.659a11.6,11.6,0,0,0,6.581,10.423.61.61,0,0,0,.289.067.629.629,0,0,0,.289-.067A11.6,11.6,0,0,0,17.53,7.659V5.626a.676.676,0,0,0-.626-.673Z",
        transform: "translate(-3.79 -2.001)",
        fill: "#009545"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_7484",
        "data-name": "Path 7484",
        d: "M11.023,2.107a.667.667,0,0,0-.781.04C8.594,3.446,6.616,4.8,4.416,4.954a.676.676,0,0,0-.626.673V7.659a11.6,11.6,0,0,0,6.581,10.423.61.61,0,0,0,.289.067C10.761,18.148,11.3,2.289,11.023,2.107Z",
        transform: "translate(-3.79 -2.001)",
        fill: "#07ad54"
      })]
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_7485",
      "data-name": "Path 7485",
      d: "M196.045,211.637l-2.3-2.054a.351.351,0,1,1,.469-.522l1.943,1.735,3.386-3.514a.351.351,0,1,1,.5.487l-3.722,3.859A.2.2,0,0,1,196.045,211.637Z",
      transform: "translate(1062.076 145.911)",
      fill: "#fff",
      stroke: "#fff",
      "stroke-width": "0.5"
    })]
  })
});
export var giftHandSvg = /*#__PURE__*/_jsxs("svg", {
  version: "1.1",
  id: "svg165",
  width: "682.66669",
  height: "682.66669",
  viewBox: "0 0 682.66669 682.66669",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("defs", {
    id: "defs169",
    children: /*#__PURE__*/_jsx("clipPath", {
      clipPathUnits: "userSpaceOnUse",
      id: "clipPath179",
      children: /*#__PURE__*/_jsx("path", {
        d: "M 0,512 H 512 V 0 H 0 Z",
        id: "path177"
      })
    })
  }), /*#__PURE__*/_jsx("g", {
    id: "g171",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)",
    children: /*#__PURE__*/_jsx("g", {
      id: "g173",
      children: /*#__PURE__*/_jsxs("g", {
        id: "g175",
        "clip-path": "url(#clipPath179)",
        children: [/*#__PURE__*/_jsx("g", {
          id: "g181",
          transform: "translate(380.6318,383.9102)",
          children: /*#__PURE__*/_jsx("path", {
            d: "m 0,0 v -155.704 m -24.309,-24.32 h -184.252 c -13.388,0 -24.336,10.941 -24.336,24.32 V 0 M 0,-155.704 c 0,-13.379 -10.949,-24.32 -24.309,-24.32",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path183"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g185",
          transform: "translate(347.7578,443.0112)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 C 27.569,32.825 -25.642,85.208 -53.948,43.596 L -83.561,0",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path187"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g189",
          transform: "translate(180.6084,443.0112)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 C -27.57,32.825 25.669,85.208 53.948,43.596 L 83.589,0",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path191"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g193",
          transform: "translate(40.2065,147.7324)",
          children: /*#__PURE__*/_jsx("path", {
            d: "m 0,0 h 40.362 c 9.19,0 16.706,-7.512 16.706,-16.696 v -93.626 c 0,-9.184 -7.516,-16.696 -16.706,-16.696 H 0 c -9.19,0 -16.707,7.512 -16.707,16.696 v 93.626 C -16.707,-7.512 -9.19,0 0,0 Z",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path195"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g197",
          transform: "translate(293.4971,103.3994)",
          children: /*#__PURE__*/_jsx("path", {
            d: "m 0,0 99.586,49.322 c 12.963,6.406 28.592,3.741 36.193,-8.56 7.63,-12.303 3.234,-27.808 -8.538,-36.17 L 10.098,-78.773 c -34.916,-23.272 -49.666,-14.144 -86.397,-4.195 -24.932,7.342 -31.881,9.325 -56.813,16.667 -27.485,8.079 -38.518,8.617 -63.11,8.617 m 106.11,55.53 56.331,-16.327 C -19.4,-22.648 -4.197,-14.371 0,0 4.198,14.372 -4.141,29.508 -18.493,33.76 l -39.398,11.678 c -32.987,9.808 -64.471,12.529 -95.19,-5.187 -10.977,-6.293 -16.082,-12.614 -35.625,-12.614 h -7.516",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path199"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g201",
          transform: "translate(172.8652,383.9102)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 H -29.244 C -41.61,0 -51.708,10.12 -51.708,22.45 v 14.201 c 0,12.359 10.098,22.45 22.464,22.45 h 241.151 c 12.339,0 22.465,-10.091 22.465,-22.45 V 22.45 C 234.372,10.12 224.246,0 211.907,0 H 91.332",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path203"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g205",
          transform: "translate(264.1973,250.231)",
          children: /*#__PURE__*/_jsx("path", {
            d: "m 0,0 -41.412,39.939 c -11.402,11.792 -11.402,31.067 0,42.859 9.928,10.29 26.379,8.93 36.789,-0.793 4.765,-4.451 4.481,-4.451 9.218,0 10.41,9.723 26.861,11.083 36.816,0.793 11.374,-11.792 11.374,-31.067 0,-42.859 z",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path207"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g209",
          transform: "translate(39.8662,295.1875)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 H 54.09",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path211"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g213",
          transform: "translate(93.9849,338.7271)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 -46.915,22.903",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path215"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g217",
          transform: "translate(93.9849,251.6484)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 -46.915,-22.903",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path219"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g221",
          transform: "translate(488.5,295.1875)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 H -54.09",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path223"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g225",
          transform: "translate(434.4102,338.7271)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 46.886,22.903",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path227"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g229",
          transform: "translate(434.4102,251.6484)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 46.886,-22.903",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path231"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "g233",
          transform: "translate(217.7651,383.9102)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M 0,0 H 0.028",
            style: "fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1",
            id: "path235"
          })
        })]
      })
    })
  })]
});
export var priceDropSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  viewBox: "0 0 67.511 40.507",
  children: /*#__PURE__*/_jsx("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(-3798.276 -415.066)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_256",
      "data-name": "Group 256",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_70",
        "data-name": "Path 70",
        d: "M3864.8,454.584a3.376,3.376,0,0,1-4.774,0L3836.6,431.16a1.688,1.688,0,0,0-2.387,0l-9.922,9.921a3.374,3.374,0,0,1-4.774,0l-20.253-20.253a3.375,3.375,0,0,1,4.774-4.773l16.673,16.672a1.687,1.687,0,0,0,2.387,0l9.922-9.921a3.375,3.375,0,0,1,4.773,0l27.005,27a3.377,3.377,0,0,1,0,4.774Z",
        fill: "#dd883d",
        "fill-rule": "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_71",
        "data-name": "Path 71",
        d: "M3848.91,448.821h8.438a1.688,1.688,0,0,0,1.688-1.688V438.7a3.376,3.376,0,1,1,6.751,0v13.5a3.375,3.375,0,0,1-3.375,3.375h-13.5a3.375,3.375,0,1,1,0-6.751Z",
        fill: "#dd883d",
        "fill-rule": "evenodd"
      })]
    })
  })
});